// ══════════════════════════════════════════════════════════════════════════════
// PanchangPage.js — Vedic Panchang Calendar (Multi-language)
// Telugu · Hindi · Tamil · Kannada · Marathi · English
// ══════════════════════════════════════════════════════════════════════════════
import { useState, useEffect } from "react";

const API = (process.env.REACT_APP_API_URL || "http://localhost:8000").replace(/\/$/, "");

// ── Language configuration ────────────────────────────────────────────────────
export const LANG = {
  te: {
    chip: "తె", dir: "ltr",
    title: "పంచాంగం", subtitle: "వేద జ్యోతిష పంచాంగం",
    back: "← వెనక్కి", todayHeader: "ఈరోజు పంచాంగం",
    keyDays: "ఈ నెల ముఖ్యమైన తిథులు", monthLabel: "మాసం",
    festivalLbl: "పండుగ", purnimaLbl: "పౌర్ణమి",
    amaavasyaLbl: "అమావాస్య", ekadashiLbl: "ఏకాదశి",
    tithiLbl: "తిథి", nakshatraLbl: "నక్షత్రం",
    yogaLbl: "యోగం", karanaLbl: "కరణం", varaLbl: "వారం",
    ekadashiGuide: "🌿 ఏకాదశి — ఉపవాస దినం. విష్ణుసహస్రనామం చదవండి.",
    purnimaGuide:  "🌕 పౌర్ణమి — సత్యనారాయణ వ్రతం, దానం, పూజ.",
    amaavasyaGuide:"🌑 అమావాస్య — పితృ తర్పణం, అమ్మవారి పూజ.",
    auspicious: "శుభయోగం", inauspicious: "అశుభం", bhadra: "భద్రకాలం",
    paksha: { "Shukla Paksha": "శుక్ల పక్షం", "Krishna Paksha": "కృష్ణ పక్షం" },
    months: ["జనవరి","ఫిబ్రవరి","మార్చి","ఏప్రిల్","మే","జూన్","జూలై","ఆగస్టు","సెప్టెంబర్","అక్టోబర్","నవంబర్","డిసెంబర్"],
    dow:  ["ఆది","సోమ","మంగళ","బుధ","గురు","శుక్ర","శని"],
    vara: ["ఆదివారం","సోమవారం","మంగళవారం","బుధవారం","గురువారం","శుక్రవారం","శనివారం"],
    deity:["సూర్యుడు","చంద్రుడు","కుజుడు","బుధుడు","బృహస్పతి","శుక్రుడు","శని"],
    masa: ["చైత్రం","వైశాఖం","జ్యేష్ఠం","ఆషాఢం","శ్రావణం","భాద్రపదం","ఆశ్వయుజం","కార్తీకం","మార్గశిరం","పుష్యం","మాఘం","ఫాల్గుణం"],
  },
  hi: {
    chip: "हि", dir: "ltr",
    title: "पंचांग", subtitle: "वैदिक ज्योतिष पंचांग",
    back: "← वापस", todayHeader: "आज का पंचांग",
    keyDays: "इस माह के मुख्य दिन", monthLabel: "माह",
    festivalLbl: "त्योहार", purnimaLbl: "पूर्णिमा",
    amaavasyaLbl: "अमावस्या", ekadashiLbl: "एकादशी",
    tithiLbl: "तिथि", nakshatraLbl: "नक्षत्र",
    yogaLbl: "योग", karanaLbl: "करण", varaLbl: "वार",
    ekadashiGuide: "🌿 एकादशी — उपवास का दिन। विष्णु सहस्रनाम का पाठ करें।",
    purnimaGuide:  "🌕 पूर्णिमा — सत्यनारायण व्रत, दान, पूजा का दिन।",
    amaavasyaGuide:"🌑 अमावस्या — पितृ तर्पण, देवी पूजा का दिन।",
    auspicious: "शुभ योग", inauspicious: "अशुभ", bhadra: "भद्रा काल",
    paksha: { "Shukla Paksha": "शुक्ल पक्ष", "Krishna Paksha": "कृष्ण पक्ष" },
    months: ["जनवरी","फ़रवरी","मार्च","अप्रैल","मई","जून","जुलाई","अगस्त","सितंबर","अक्टूबर","नवंबर","दिसंबर"],
    dow:  ["रवि","सोम","मंगल","बुध","गुरु","शुक्र","शनि"],
    vara: ["रविवार","सोमवार","मंगलवार","बुधवार","गुरुवार","शुक्रवार","शनिवार"],
    deity:["सूर्य","चन्द्र","मंगल","बुध","बृहस्पति","शुक्र","शनि"],
    masa: ["चैत्र","वैशाख","ज्येष्ठ","आषाढ","श्रावण","भाद्रपद","अश्विन","कार्तिक","मार्गशीर्ष","पौष","माघ","फाल्गुन"],
  },
  ta: {
    chip: "த", dir: "ltr",
    title: "பஞ்சாங்கம்", subtitle: "வேத ஜோதிட பஞ்சாங்கம்",
    back: "← திரும்பு", todayHeader: "இன்றைய பஞ்சாங்கம்",
    keyDays: "இம்மாத முக்கிய நாட்கள்", monthLabel: "மாதம்",
    festivalLbl: "திருவிழா", purnimaLbl: "பௌர்ணமி",
    amaavasyaLbl: "அமாவாசை", ekadashiLbl: "ஏகாதசி",
    tithiLbl: "திதி", nakshatraLbl: "நட்சத்திரம்",
    yogaLbl: "யோகம்", karanaLbl: "கரணம்", varaLbl: "வாரம்",
    ekadashiGuide: "🌿 ஏகாதசி — விரத நாள். விஷ்ணு சஹஸ்ரநாமம் பாராயணம் செய்யுங்கள்.",
    purnimaGuide:  "🌕 பௌர்ணமி — சத்யநாராயண விரதம், தானம், பூஜை.",
    amaavasyaGuide:"🌑 அமாவாசை — பிதுர் தர்ப்பணம், தேவி பூஜை.",
    auspicious: "சுப யோகம்", inauspicious: "அசுபம்", bhadra: "பத்திரா காலம்",
    paksha: { "Shukla Paksha": "சுக்ல பக்ஷம்", "Krishna Paksha": "கிருஷ்ண பக்ஷம்" },
    months: ["ஜனவரி","பிப்ரவரி","மார்ச்","ஏப்ரல்","மே","ஜூன்","ஜூலை","ஆகஸ்ட்","செப்டம்பர்","அக்டோபர்","நவம்பர்","டிசம்பர்"],
    dow:  ["ஞா","திங்","செவ்","புத","வியா","வெள்","சனி"],
    vara: ["ஞாயிறு","திங்கள்","செவ்வாய்","புதன்","வியாழன்","வெள்ளி","சனி"],
    deity:["சூரியன்","சந்திரன்","செவ்வாய்","புதன்","குரு","சுக்ரன்","சனீஸ்வரன்"],
    masa: ["சித்திரை","வைகாசி","ஆனி","ஆடி","ஆவணி","புரட்டாசி","ஐப்பசி","கார்த்திகை","மார்கழி","தை","மாசி","பங்குனி"],
  },
  kn: {
    chip: "ಕ", dir: "ltr",
    title: "ಪಂಚಾಂಗ", subtitle: "ವೈದಿಕ ಜ್ಯೋತಿಷ ಪಂಚಾಂಗ",
    back: "← ಹಿಂದೆ", todayHeader: "ಇಂದಿನ ಪಂಚಾಂಗ",
    keyDays: "ಈ ತಿಂಗಳ ಮುಖ್ಯ ದಿನಗಳು", monthLabel: "ಮಾಸ",
    festivalLbl: "ಹಬ್ಬ", purnimaLbl: "ಹುಣ್ಣಿಮೆ",
    amaavasyaLbl: "ಅಮಾವಾಸ್ಯೆ", ekadashiLbl: "ಏಕಾದಶಿ",
    tithiLbl: "ತಿಥಿ", nakshatraLbl: "ನಕ್ಷತ್ರ",
    yogaLbl: "ಯೋಗ", karanaLbl: "ಕರಣ", varaLbl: "ವಾರ",
    ekadashiGuide: "🌿 ಏಕಾದಶಿ — ಉಪವಾಸ ದಿನ. ವಿಷ್ಣು ಸಹಸ್ರನಾಮ ಪಾರಾಯಣ ಮಾಡಿ.",
    purnimaGuide:  "🌕 ಹುಣ್ಣಿಮೆ — ಸತ್ಯನಾರಾಯಣ ವ್ರತ, ದಾನ, ಪೂಜೆ.",
    amaavasyaGuide:"🌑 ಅಮಾವಾಸ್ಯೆ — ಪಿತೃ ತರ್ಪಣ, ದೇವಿ ಪೂಜೆ.",
    auspicious: "ಶುಭ ಯೋಗ", inauspicious: "ಅಶುಭ", bhadra: "ಭದ್ರಾ ಕಾಲ",
    paksha: { "Shukla Paksha": "ಶುಕ್ಲ ಪಕ್ಷ", "Krishna Paksha": "ಕೃಷ್ಣ ಪಕ್ಷ" },
    months: ["ಜನವರಿ","ಫೆಬ್ರವರಿ","ಮಾರ್ಚ್","ಏಪ್ರಿಲ್","ಮೇ","ಜೂನ್","ಜುಲೈ","ಆಗಸ್ಟ್","ಸೆಪ್ಟೆಂಬರ್","ಅಕ್ಟೋಬರ್","ನವೆಂಬರ್","ಡಿಸೆಂಬರ್"],
    dow:  ["ಭಾನು","ಸೋಮ","ಮಂಗಳ","ಬುಧ","ಗುರು","ಶುಕ್ರ","ಶನಿ"],
    vara: ["ಭಾನುವಾರ","ಸೋಮವಾರ","ಮಂಗಳವಾರ","ಬುಧವಾರ","ಗುರುವಾರ","ಶುಕ್ರವಾರ","ಶನಿವಾರ"],
    deity:["ಸೂರ್ಯ","ಚಂದ್ರ","ಮಂಗಳ","ಬುಧ","ಗುರು","ಶುಕ್ರ","ಶನಿ"],
    masa: ["ಚೈತ್ರ","ವೈಶಾಖ","ಜ್ಯೇಷ್ಠ","ಆಷಾಢ","ಶ್ರಾವಣ","ಭಾದ್ರಪದ","ಅಶ್ವಿನ","ಕಾರ್ತಿಕ","ಮಾರ್ಗಶಿರ","ಪೌಷ","ಮಾಘ","ಫಾಲ್ಗುಣ"],
  },
  mr: {
    chip: "म", dir: "ltr",
    title: "पंचांग", subtitle: "वैदिक ज्योतिष पंचांग",
    back: "← मागे", todayHeader: "आजचे पंचांग",
    keyDays: "या महिन्याचे महत्त्वाचे दिवस", monthLabel: "माह",
    festivalLbl: "सण", purnimaLbl: "पौर्णिमा",
    amaavasyaLbl: "अमावस्या", ekadashiLbl: "एकादशी",
    tithiLbl: "तिथी", nakshatraLbl: "नक्षत्र",
    yogaLbl: "योग", karanaLbl: "करण", varaLbl: "वार",
    ekadashiGuide: "🌿 एकादशी — उपवासाचा दिवस. विष्णु सहस्रनाम वाचा.",
    purnimaGuide:  "🌕 पौर्णिमा — सत्यनारायण व्रत, दान, पूजेचा दिवस.",
    amaavasyaGuide:"🌑 अमावस्या — पितृ तर्पण, देवी पूजेचा दिवस.",
    auspicious: "शुभ योग", inauspicious: "अशुभ", bhadra: "भद्रा काल",
    paksha: { "Shukla Paksha": "शुक्ल पक्ष", "Krishna Paksha": "कृष्ण पक्ष" },
    months: ["जानेवारी","फेब्रुवारी","मार्च","एप्रिल","मे","जून","जुलै","ऑगस्ट","सप्टेंबर","ऑक्टोबर","नोव्हेंबर","डिसेंबर"],
    dow:  ["रवि","सोम","मंगळ","बुध","गुरु","शुक्र","शनि"],
    vara: ["रविवार","सोमवार","मंगळवार","बुधवार","गुरुवार","शुक्रवार","शनिवार"],
    deity:["सूर्य","चंद्र","मंगळ","बुध","गुरु","शुक्र","शनि"],
    masa: ["चैत्र","वैशाख","ज्येष्ठ","आषाढ","श्रावण","भाद्रपद","अश्विन","कार्तिक","मार्गशीर्ष","पौष","माघ","फाल्गुन"],
  },
  en: {
    chip: "EN", dir: "ltr",
    title: "Panchang", subtitle: "Vedic Astrology Calendar",
    back: "← Back", todayHeader: "TODAY'S PANCHANG",
    keyDays: "KEY DAYS THIS MONTH", monthLabel: "Month",
    festivalLbl: "Festival", purnimaLbl: "Purnima",
    amaavasyaLbl: "Amavasya", ekadashiLbl: "Ekadashi",
    tithiLbl: "Tithi", nakshatraLbl: "Nakshatra",
    yogaLbl: "Yoga", karanaLbl: "Karana", varaLbl: "Vara",
    ekadashiGuide: "🌿 Ekadashi — fasting day. Ideal for Vishnu Sahasranama.",
    purnimaGuide:  "🌕 Purnima — Satyanarayan vrata, charity, worship.",
    amaavasyaGuide:"🌑 Amavasya — Pitru tarpana, Devi puja.",
    auspicious: "Auspicious", inauspicious: "Inauspicious", bhadra: "Bhadra — avoid new work",
    paksha: { "Shukla Paksha": "Shukla Paksha", "Krishna Paksha": "Krishna Paksha" },
    months: ["January","February","March","April","May","June","July","August","September","October","November","December"],
    dow:  ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
    vara: ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
    deity:["Surya","Chandra","Mangala","Budha","Brihaspati","Shukra","Shani"],
    masa: ["Chaitra","Vaishakha","Jyeshtha","Ashadha","Shravana","Bhadrapada","Ashwayuja","Kartika","Margashira","Pushya","Magha","Phalguna"],
  },
};

// ── Translation tables (EN key → local script) ────────────────────────────────
// Keys match TITHI_NAMES_EN / NAKSHATRA_NAMES_EN / etc. from panchang.py exactly

export const TITHI_TRANS = {
  hi: { Padyami:"प्रतिपदा",Vidiya:"द्वितीया",Tadiya:"तृतीया",Chaviti:"चतुर्थी",
        Panchami:"पंचमी",Shashti:"षष्ठी",Saptami:"सप्तमी",Ashtami:"अष्टमी",
        Navami:"नवमी",Dashami:"दशमी",Ekadashi:"एकादशी",Dwadashi:"द्वादशी",
        Trayodashi:"त्रयोदशी",Chaturdashi:"चतुर्दशी",Purnima:"पूर्णिमा",Amavasya:"अमावस्या" },
  ta: { Padyami:"பிரதமை",Vidiya:"துவிதியை",Tadiya:"திரிதியை",Chaviti:"சதுர்த்தி",
        Panchami:"பஞ்சமி",Shashti:"சஷ்டி",Saptami:"சப்தமி",Ashtami:"அஷ்டமி",
        Navami:"நவமி",Dashami:"தசமி",Ekadashi:"ஏகாதசி",Dwadashi:"துவாதசி",
        Trayodashi:"திரயோதசி",Chaturdashi:"சதுர்த்தசி",Purnima:"பௌர்ணமி",Amavasya:"அமாவாசை" },
  kn: { Padyami:"ಪ್ರತಿಪದ",Vidiya:"ದ್ವಿತೀಯ",Tadiya:"ತೃತೀಯ",Chaviti:"ಚತುರ್ಥಿ",
        Panchami:"ಪಂಚಮಿ",Shashti:"ಷಷ್ಠಿ",Saptami:"ಸಪ್ತಮಿ",Ashtami:"ಅಷ್ಟಮಿ",
        Navami:"ನವಮಿ",Dashami:"ದಶಮಿ",Ekadashi:"ಏಕಾದಶಿ",Dwadashi:"ದ್ವಾದಶಿ",
        Trayodashi:"ತ್ರಯೋದಶಿ",Chaturdashi:"ಚತುರ್ದಶಿ",Purnima:"ಹುಣ್ಣಿಮೆ",Amavasya:"ಅಮಾವಾಸ್ಯೆ" },
  mr: { Padyami:"प्रतिपदा",Vidiya:"द्वितीया",Tadiya:"तृतीया",Chaviti:"चतुर्थी",
        Panchami:"पंचमी",Shashti:"षष्ठी",Saptami:"सप्तमी",Ashtami:"अष्टमी",
        Navami:"नवमी",Dashami:"दशमी",Ekadashi:"एकादशी",Dwadashi:"द्वादशी",
        Trayodashi:"त्रयोदशी",Chaturdashi:"चतुर्दशी",Purnima:"पौर्णिमा",Amavasya:"अमावस्या" },
};

export const NAK_TRANS = {
  hi: { Ashwini:"अश्विनी",Bharani:"भरणी",Krittika:"कृत्तिका",Rohini:"रोहिणी",
        Mrigashira:"मृगशिरा",Ardra:"आर्द्रा",Punarvasu:"पुनर्वसु",Pushyami:"पुष्य",
        Ashlesa:"आश्लेषा",Makha:"मघा",Pubba:"पूर्व फाल्गुनी",Uttara:"उत्तर फाल्गुनी",
        Hasta:"हस्त",Chitta:"चित्रा",Swati:"स्वाती",Vishakha:"विशाखा",
        Anuradha:"अनुराधा",Jyeshtha:"ज्येष्ठा",Moola:"मूल",Purvashadha:"पूर्वाषाढा",
        Uttarashadha:"उत्तराषाढा",Shravana:"श्रवण",Dhanishtha:"धनिष्ठा",
        Shatabhisha:"शतभिषा","Purva Bhadra":"पूर्व भाद्रपद","Uttara Bhadra":"उत्तर भाद्रपद",Revati:"रेवती" },
  ta: { Ashwini:"அசுவினி",Bharani:"பரணி",Krittika:"கார்த்திகை",Rohini:"ரோகிணி",
        Mrigashira:"மிருகசீரிஷம்",Ardra:"திருவாதிரை",Punarvasu:"புனர்பூசம்",Pushyami:"பூசம்",
        Ashlesa:"ஆயில்யம்",Makha:"மகம்",Pubba:"பூரம்",Uttara:"உத்திரம்",
        Hasta:"அஸ்தம்",Chitta:"சித்திரை",Swati:"சுவாதி",Vishakha:"விசாகம்",
        Anuradha:"அனுஷம்",Jyeshtha:"கேட்டை",Moola:"மூலம்",Purvashadha:"பூராடம்",
        Uttarashadha:"உத்திராடம்",Shravana:"திருவோணம்",Dhanishtha:"அவிட்டம்",
        Shatabhisha:"சதயம்","Purva Bhadra":"பூரட்டாதி","Uttara Bhadra":"உத்திரட்டாதி",Revati:"ரேவதி" },
  kn: { Ashwini:"ಅಶ್ವಿನಿ",Bharani:"ಭರಣಿ",Krittika:"ಕೃತ್ತಿಕ",Rohini:"ರೋಹಿಣಿ",
        Mrigashira:"ಮೃಗಶಿರ",Ardra:"ಆರ್ದ್ರ",Punarvasu:"ಪುನರ್ವಸು",Pushyami:"ಪುಷ್ಯ",
        Ashlesa:"ಆಶ್ಲೇಷ",Makha:"ಮಘ",Pubba:"ಪೂರ್ವ ಫಲ್ಗುಣಿ",Uttara:"ಉತ್ತರ ಫಲ್ಗುಣಿ",
        Hasta:"ಹಸ್ತ",Chitta:"ಚಿತ್ರ",Swati:"ಸ್ವಾತಿ",Vishakha:"ವಿಶಾಖ",
        Anuradha:"ಅನುರಾಧ",Jyeshtha:"ಜ್ಯೇಷ್ಠ",Moola:"ಮೂಲ",Purvashadha:"ಪೂರ್ವಾಷಾಢ",
        Uttarashadha:"ಉತ್ತರಾಷಾಢ",Shravana:"ಶ್ರವಣ",Dhanishtha:"ಧನಿಷ್ಠ",
        Shatabhisha:"ಶತಭಿಷ","Purva Bhadra":"ಪೂರ್ವಭಾದ್ರ","Uttara Bhadra":"ಉತ್ತರಭಾದ್ರ",Revati:"ರೇವತಿ" },
  mr: { Ashwini:"अश्विनी",Bharani:"भरणी",Krittika:"कृत्तिका",Rohini:"रोहिणी",
        Mrigashira:"मृगशीर्ष",Ardra:"आर्द्रा",Punarvasu:"पुनर्वसू",Pushyami:"पुष्य",
        Ashlesa:"आश्लेषा",Makha:"मघा",Pubba:"पूर्वा फाल्गुनी",Uttara:"उत्तरा फाल्गुनी",
        Hasta:"हस्त",Chitta:"चित्रा",Swati:"स्वाती",Vishakha:"विशाखा",
        Anuradha:"अनुराधा",Jyeshtha:"ज्येष्ठा",Moola:"मूळ",Purvashadha:"पूर्वाषाढा",
        Uttarashadha:"उत्तराषाढा",Shravana:"श्रवण",Dhanishtha:"धनिष्ठा",
        Shatabhisha:"शततारका","Purva Bhadra":"पूर्वाभाद्रपदा","Uttara Bhadra":"उत्तराभाद्रपदा",Revati:"रेवती" },
};

const YOGA_TRANS = {
  hi: { Vishkambha:"विष्कम्भ",Priti:"प्रीति",Ayushman:"आयुष्मान",Saubhagya:"सौभाग्य",
        Shobhana:"शोभन",Atiganda:"अतिगण्ड",Sukarma:"सुकर्मा",Dhriti:"धृति",
        Shula:"शूल",Ganda:"गण्ड",Vriddhi:"वृद्धि",Dhruva:"ध्रुव",
        Vyaghata:"व्याघात",Harshana:"हर्षण",Vajra:"वज्र",Siddhi:"सिद्धि",
        Vyatipata:"व्यतीपात",Variyan:"वरीयान",Parigha:"परिघ",Shiva:"शिव",
        Siddha:"सिद्ध",Sadhya:"साध्य",Shubha:"शुभ",Shukla:"शुक्ल",
        Brahma:"ब्रह्म",Indra:"इन्द्र",Vaidhrti:"वैधृति" },
  ta: { Vishkambha:"விஷ்கம்பம்",Priti:"பிரீதி",Ayushman:"ஆயுஷ்மான்",Saubhagya:"சௌபாக்யம்",
        Shobhana:"சோபனம்",Atiganda:"அதிகண்டம்",Sukarma:"சுகர்மம்",Dhriti:"திருதி",
        Shula:"சூலம்",Ganda:"கண்டம்",Vriddhi:"விருத்தி",Dhruva:"துருவம்",
        Vyaghata:"வியாகாதம்",Harshana:"ஹர்ஷணம்",Vajra:"வஜ்ரம்",Siddhi:"சித்தி",
        Vyatipata:"வியதீபாதம்",Variyan:"வரியான்",Parigha:"பரிகம்",Shiva:"சிவம்",
        Siddha:"சித்தம்",Sadhya:"சாத்தியம்",Shubha:"சுபம்",Shukla:"சுக்லம்",
        Brahma:"பிரம்மம்",Indra:"இந்திரம்",Vaidhrti:"வைதிருதி" },
  kn: { Vishkambha:"ವಿಷ್ಕಂಭ",Priti:"ಪ್ರೀತಿ",Ayushman:"ಆಯುಷ್ಮಾನ್",Saubhagya:"ಸೌಭಾಗ್ಯ",
        Shobhana:"ಶೋಭನ",Atiganda:"ಅತಿಗಂಡ",Sukarma:"ಸುಕರ್ಮ",Dhriti:"ಧೃತಿ",
        Shula:"ಶೂಲ",Ganda:"ಗಂಡ",Vriddhi:"ವೃದ್ಧಿ",Dhruva:"ಧ್ರುವ",
        Vyaghata:"ವ್ಯಾಘಾತ",Harshana:"ಹರ್ಷಣ",Vajra:"ವಜ್ರ",Siddhi:"ಸಿದ್ಧಿ",
        Vyatipata:"ವ್ಯತೀಪಾತ",Variyan:"ವರೀಯಾನ",Parigha:"ಪರಿಘ",Shiva:"ಶಿವ",
        Siddha:"ಸಿದ್ಧ",Sadhya:"ಸಾಧ್ಯ",Shubha:"ಶುಭ",Shukla:"ಶುಕ್ಲ",
        Brahma:"ಬ್ರಹ್ಮ",Indra:"ಇಂದ್ರ",Vaidhrti:"ವೈಧೃತಿ" },
  mr: { Vishkambha:"विष्कंभ",Priti:"प्रीती",Ayushman:"आयुष्मान",Saubhagya:"सौभाग्य",
        Shobhana:"शोभन",Atiganda:"अतिगंड",Sukarma:"सुकर्मा",Dhriti:"धृती",
        Shula:"शूल",Ganda:"गंड",Vriddhi:"वृद्धी",Dhruva:"ध्रुव",
        Vyaghata:"व्याघात",Harshana:"हर्षण",Vajra:"वज्र",Siddhi:"सिद्धी",
        Vyatipata:"व्यतीपात",Variyan:"वरीयान",Parigha:"परिघ",Shiva:"शिव",
        Siddha:"सिद्ध",Sadhya:"साध्य",Shubha:"शुभ",Shukla:"शुक्ल",
        Brahma:"ब्रह्म",Indra:"इंद्र",Vaidhrti:"वैधृती" },
};

const KARANA_TRANS = {
  hi: { Bava:"बव",Balava:"बालव",Kaulava:"कौलव",Taitila:"तैतिल",
        Gara:"गर",Vanija:"वणिज",Vishti:"विष्टि",Shakuni:"शकुनि",
        Chatushpada:"चतुष्पद",Naga:"नाग",Kimstughna:"किंस्तुघ्न" },
  ta: { Bava:"பவம்",Balava:"பாலவம்",Kaulava:"கௌலவம்",Taitila:"தைதிலம்",
        Gara:"கரஜம்",Vanija:"வணிஜம்",Vishti:"விஷ்டி",Shakuni:"சகுனி",
        Chatushpada:"சதுஷ்பாதம்",Naga:"நாகம்",Kimstughna:"கிம்ஸ்துக்னம்" },
  kn: { Bava:"ಬವ",Balava:"ಬಾಲವ",Kaulava:"ಕೌಲವ",Taitila:"ತೈತಿಲ",
        Gara:"ಗರ",Vanija:"ವಣಿಜ",Vishti:"ವಿಷ್ಟಿ",Shakuni:"ಶಕುನಿ",
        Chatushpada:"ಚತುಷ್ಪಾದ",Naga:"ನಾಗ",Kimstughna:"ಕಿಂಸ್ತುಘ್ನ" },
  mr: { Bava:"बव",Balava:"बालव",Kaulava:"कौलव",Taitila:"तैतिल",
        Gara:"गर",Vanija:"वणिज",Vishti:"विष्टी",Shakuni:"शकुनी",
        Chatushpada:"चतुष्पाद",Naga:"नाग",Kimstughna:"किंस्तुघ्न" },
};

// ── Muhurta message templates (positives/warnings from API) ───────────────────
const MUHURTA_MSGS = {
  te: {
    vara_good:     (n)    => `${n} వారం ఈ కార్యానికి శుభకరమైనది`,
    vara_bad:      (n)    => `${n} వారం అనుకూలంగా లేదు — వాయిదా వేయండి`,
    tithi_good:    (n, p) => `${n} (${p}) శుభ తిథి`,
    tithi_bad:     (n)    => `${n} ఈ కార్యానికి అనుకూలంగా లేదు`,
    nak_good:      (n)    => `${n} నక్షత్రం ఈ కార్యాన్ని బలంగా మద్దతు ఇస్తుంది`,
    nak_bad:       (n)    => `${n} నక్షత్రం అశుభం — నివారించడం మంచిది`,
    yoga_good:     (n)    => `${n} యోగం శుభకరమైనది`,
    yoga_bad:      (n)    => `${n} యోగం అశుభం`,
    vishti:        ()     => `విష్టి కరణం సక్రియంగా ఉంది — కొత్త పనులు ప్రారంభించకండి`,
    amavasya:      ()     => `అమావాస్య — కొత్త కార్యాలకు అనుకూలంగా లేదు`,
    shukla_paksha: ()     => `శుక్ల పక్షం — కొత్త ప్రారంభాలకు అత్యంత శుభకరం`,
    purnima:       ()     => `పౌర్ణమి — చంద్ర శక్తి ఈ కార్యానికి అనుకూలం`,
  },
  hi: {
    vara_good:     (n)    => `${n} इस कार्य के लिए शुभ दिन है`,
    vara_bad:      (n)    => `${n} अनुकूल नहीं — स्थगित करने पर विचार करें`,
    tithi_good:    (n, p) => `${n} (${p}) शुभ तिथि है`,
    tithi_bad:     (n)    => `${n} इस कार्य के लिए अशुभ है`,
    nak_good:      (n)    => `${n} नक्षत्र इस कार्य को बलवान समर्थन देता है`,
    nak_bad:       (n)    => `${n} नक्षत्र अशुभ — टालना उचित है`,
    yoga_good:     (n)    => `${n} योग आज शुभ है`,
    yoga_bad:      (n)    => `${n} योग अशुभ है`,
    vishti:        ()     => `विष्टि (भद्रा) करण सक्रिय — नए काम शुरू न करें`,
    amavasya:      ()     => `अमावस्या — नए कार्य या यात्रा की सलाह नहीं`,
    shukla_paksha: ()     => `शुक्ल पक्ष (बढ़ता चाँद) — नए आरंभ के लिए विशेष शुभ`,
    purnima:       ()     => `पूर्णिमा — चंद्र ऊर्जा इस कार्य में सहायक है`,
  },
  ta: {
    vara_good:     (n)    => `${n} இந்தச் செயலுக்கு சுபமான நாள்`,
    vara_bad:      (n)    => `${n} சாதகமில்லை — ஒத்திவைக்கவும்`,
    tithi_good:    (n, p) => `${n} (${p}) சுப திதி`,
    tithi_bad:     (n)    => `${n} இந்தச் செயலுக்கு அசுபமானது`,
    nak_good:      (n)    => `${n} நட்சத்திரம் இந்தச் செயலை வலுவாக ஆதரிக்கிறது`,
    nak_bad:       (n)    => `${n} நட்சத்திரம் அசுபமானது — தவிர்க்கவும்`,
    yoga_good:     (n)    => `${n} யோகம் இன்று சுபமானது`,
    yoga_bad:      (n)    => `${n} யோகம் அசுபமானது`,
    vishti:        ()     => `விஷ்டி கரணம் உள்ளது — புதிய தொடக்கங்கள் வேண்டாம்`,
    amavasya:      ()     => `அமாவாசை — புதிய முயற்சிகளுக்கு உகந்தது அல்ல`,
    shukla_paksha: ()     => `சுக்ல பக்ஷம் — புதிய தொடக்கங்களுக்கு சிறந்தது`,
    purnima:       ()     => `பௌர்ணமி — சந்திர சக்தி இந்தச் செயலுக்கு உதவுகிறது`,
  },
  kn: {
    vara_good:     (n)    => `${n} ಈ ಕಾರ್ಯಕ್ಕೆ ಶುಭ ದಿನ`,
    vara_bad:      (n)    => `${n} ಅನುಕೂಲವಲ್ಲ — ಮುಂದೂಡಿ`,
    tithi_good:    (n, p) => `${n} (${p}) ಶುಭ ತಿಥಿ`,
    tithi_bad:     (n)    => `${n} ಈ ಕಾರ್ಯಕ್ಕೆ ಅಶುಭ`,
    nak_good:      (n)    => `${n} ನಕ್ಷತ್ರ ಈ ಕಾರ್ಯಕ್ಕೆ ಬಲವಾದ ಬೆಂಬಲ ನೀಡುತ್ತದೆ`,
    nak_bad:       (n)    => `${n} ನಕ್ಷತ್ರ ಅಶುಭ — ತಪ್ಪಿಸುವುದು ಉತ್ತಮ`,
    yoga_good:     (n)    => `${n} ಯೋಗ ಇಂದು ಶುಭ`,
    yoga_bad:      (n)    => `${n} ಯೋಗ ಅಶುಭ`,
    vishti:        ()     => `ವಿಷ್ಟಿ ಕರಣ ಸಕ್ರಿಯ — ಹೊಸ ಕಾರ್ಯ ಪ್ರಾರಂಭಿಸಬೇಡಿ`,
    amavasya:      ()     => `ಅಮಾವಾಸ್ಯೆ — ಹೊಸ ಉದ್ಯಮಗಳಿಗೆ ಶಿಫಾರಸು ಇಲ್ಲ`,
    shukla_paksha: ()     => `ಶುಕ್ಲ ಪಕ್ಷ — ಹೊಸ ಆರಂಭಗಳಿಗೆ ವಿಶೇಷ ಶುಭ`,
    purnima:       ()     => `ಹುಣ್ಣಿಮೆ — ಚಂದ್ರ ಶಕ್ತಿ ಈ ಕಾರ್ಯಕ್ಕೆ ಅನುಕೂಲ`,
  },
  mr: {
    vara_good:     (n)    => `${n} या कार्यासाठी शुभ वार`,
    vara_bad:      (n)    => `${n} अनुकूल नाही — पुढे ढकलण्याचा विचार करा`,
    tithi_good:    (n, p) => `${n} (${p}) शुभ तिथी`,
    tithi_bad:     (n)    => `${n} या कार्यासाठी अशुभ`,
    nak_good:      (n)    => `${n} नक्षत्र या कार्यास सशक्त पाठिंबा देते`,
    nak_bad:       (n)    => `${n} नक्षत्र अशुभ — टाळणे उचित`,
    yoga_good:     (n)    => `${n} योग आज शुभ`,
    yoga_bad:      (n)    => `${n} योग अशुभ`,
    vishti:        ()     => `विष्टी करण सक्रिय — नवीन कार्य सुरू करू नका`,
    amavasya:      ()     => `अमावस्या — नवीन उद्यमांसाठी योग्य नाही`,
    shukla_paksha: ()     => `शुक्ल पक्ष — नवीन सुरुवातींसाठी विशेष शुभ`,
    purnima:       ()     => `पौर्णिमा — चंद्र ऊर्जा या कार्यास अनुकूल`,
  },
};

const LANG_LOCALE = { te:"te-IN", hi:"hi-IN", ta:"ta-IN", kn:"kn-IN", mr:"mr-IN", en:"en-IN" };

function formatMsg(msgObj, lang) {
  if (!msgObj || typeof msgObj === "string") return msgObj || "";
  const { key, text, name, name_te, paksha, paksha_te } = msgObj;
  const tpls = MUHURTA_MSGS[lang];
  if (!tpls || !tpls[key]) return text || "";
  // translate element name
  let tName = name;
  if (lang === "te" && name_te) {
    tName = name_te;
  } else if (name && lang !== "en") {
    if (key.startsWith("vara_"))  tName = tVara(name, lang);
    else if (key.startsWith("nak_"))   tName = tr(name, lang, NAK_TRANS);
    else if (key.startsWith("tithi_")) tName = tr(name, lang, TITHI_TRANS);
    else if (key.startsWith("yoga_"))  tName = tr(name, lang, YOGA_TRANS);
  }
  // translate paksha
  let tPaksha = paksha;
  if (paksha) {
    if (lang === "te" && paksha_te) tPaksha = paksha_te;
    else tPaksha = (LANG[lang]?.paksha?.[paksha]) || paksha;
  }
  return tpls[key](tName, tPaksha);
}

// ── Muhurta UI translations ────────────────────────────────────────────────────
const MUHURTA_LANG = {
  te: {
    heading:"ముహూర్తం", subtitle:"మీ కార్యక్రమానికి తేదీ శుభమా అని తెలుసుకోండి — వార, తిథి, నక్షత్రం, యోగం, కరణం ఆధారంగా.",
    chooseActivity:"కార్యక్రమం ఎంచుకోండి", checkDate:"తేదీ తనిఖీ చేయండి",
    consulting:"పంచాంగం సంప్రదిస్తున్నాం…",
    findBest:"✨ వచ్చే 30 రోజుల్లో శుభ తేదీలు →", bestHeader:"వచ్చే 30 రోజుల శుభ తేదీలు",
    scanning:"క్యాలెండర్ స్కాన్ చేస్తున్నాం…",
    noDateFound:"ఈ కార్యక్రమానికి వచ్చే 30 రోజుల్లో శుభ తేదీలు లేవు.", backToCheck:"← తేదీ తనిఖీకి తిరిగి",
    rahuKalam:"రాహు కాలం", avoidBetween:"ఈ సమయంలో ఏ పని ప్రారంభించకండి", today:"ఈరోజు",
    vara:"వారం", tithi:"తిథి", nakshatra:"నక్షత్రం", yoga:"యోగం",
    disclaimer:"ముహూర్త స్కోరు వార, తిథి, నక్షత్రం, యోగం, కరణం ఆధారంగా గణించబడుతుంది. వివాహం వంటి నిర్ణయాలకు జ్యోతిషుడిని సంప్రదించండి.",
    excellent:"అత్యుత్తమం", good:"శుభం", neutral:"సాధారణం", avoid:"నివారించండి",
    activities:{
      travel:{label:"ప్రయాణం",desc:"రోడ్డు, రైలు లేదా విమానంలో"},
      interview:{label:"ఉద్యోగం / ఇంటర్వ్యూ",desc:"కెరీర్ నిర్ణయం లేదా మొదటి రోజు"},
      business:{label:"నూతన వ్యాపారం",desc:"వ్యాపార ప్రారంభం లేదా ఒప్పందం"},
      marriage:{label:"వివాహం",desc:"పెళ్లి లేదా నిశ్చితార్థం"},
      medical:{label:"వైద్యం",desc:"శస్త్రచికిత్స లేదా చికిత్స ప్రారంభం"},
      education:{label:"విద్యారంభం",desc:"విద్యారంభం లేదా కొత్త కోర్సు"},
      property:{label:"గృహప్రవేశం",desc:"గృహప్రవేశం లేదా కొనుగోలు"},
    },
  },
  hi: {
    heading:"मुहूर्त", subtitle:"अपने कार्य के लिए शुभ तिथि देखें — वार, तिथि, नक्षत्र, योग और करण के आधार पर।",
    chooseActivity:"कार्य चुनें", checkDate:"तिथि जाँचें",
    consulting:"पंचांग देख रहे हैं…",
    findBest:"✨ अगले 30 दिनों में शुभ तिथियाँ →", bestHeader:"अगले 30 दिनों की शुभ तिथियाँ",
    scanning:"पंचांग स्कैन हो रहा है…",
    noDateFound:"इस कार्य के लिए अगले 30 दिनों में शुभ तिथि नहीं मिली।", backToCheck:"← तिथि जाँच पर वापस",
    rahuKalam:"राहु काल", avoidBetween:"इस समय कोई नया कार्य न करें", today:"आज",
    vara:"वार", tithi:"तिथि", nakshatra:"नक्षत्र", yoga:"योग",
    disclaimer:"मुहूर्त स्कोर वार, तिथि, नक्षत्र, योग और करण पर आधारित। विवाह जैसे महत्वपूर्ण निर्णयों के लिए ज्योतिषी से परामर्श लें।",
    excellent:"उत्तम", good:"शुभ", neutral:"सामान्य", avoid:"टालें",
    activities:{
      travel:{label:"यात्रा",desc:"सड़क, रेल या हवाई यात्रा"},
      interview:{label:"नौकरी / साक्षात्कार",desc:"करियर निर्णय या पहला दिन"},
      business:{label:"नया व्यवसाय",desc:"व्यापार शुरुआत या अनुबंध"},
      marriage:{label:"विवाह",desc:"शादी या सगाई की तारीख"},
      medical:{label:"चिकित्सा",desc:"शल्यक्रिया या उपचार प्रारंभ"},
      education:{label:"विद्यारंभ",desc:"विद्यारंभ या नया कोर्स"},
      property:{label:"गृह प्रवेश",desc:"गृह प्रवेश या खरीद"},
    },
  },
  ta: {
    heading:"முகூர்த்தம்", subtitle:"உங்கள் செயலுக்கு நாள் சுபமா என அறியுங்கள் — வாரம், திதி, நட்சத்திரம், யோகம், கரணம் அடிப்படையில்.",
    chooseActivity:"செயல் தேர்ந்தெடுக்கவும்", checkDate:"தேதி சரிபார்க்கவும்",
    consulting:"பஞ்சாங்கம் பார்க்கிறோம்…",
    findBest:"✨ அடுத்த 30 நாட்களில் சுப தேதிகள் →", bestHeader:"அடுத்த 30 நாட்களின் சுப தேதிகள்",
    scanning:"நாட்காட்டி ஆராய்கிறோம்…",
    noDateFound:"இந்தச் செயலுக்கு அடுத்த 30 நாட்களில் சிறப்பான சுப தேதிகள் இல்லை.", backToCheck:"← தேதி சரிபார்ப்புக்கு திரும்பு",
    rahuKalam:"ராகு காலம்", avoidBetween:"இந்த நேரத்தில் புதிதாக எதுவும் தொடங்க வேண்டாம்", today:"இன்று",
    vara:"வாரம்", tithi:"திதி", nakshatra:"நட்சத்திரம்", yoga:"யோகம்",
    disclaimer:"முகூர்த்த மதிப்பெண் வாரம், திதி, நட்சத்திரம், யோகம், கரணம் அடிப்படையில். திருமணம் போன்ற முக்கியமான முடிவுகளுக்கு ஜோதிடரை கலந்தாலோசியுங்கள்.",
    excellent:"சிறந்தது", good:"சுபம்", neutral:"சாதாரணம்", avoid:"தவிர்க்கவும்",
    activities:{
      travel:{label:"பயணம்",desc:"சாலை, ரயில் அல்லது விமானம்"},
      interview:{label:"வேலை / நேர்காணல்",desc:"தொழில் முடிவு அல்லது முதல் நாள்"},
      business:{label:"புதிய தொழில்",desc:"வணிக தொடக்கம் அல்லது ஒப்பந்தம்"},
      marriage:{label:"திருமணம்",desc:"திருமண அல்லது நிச்சயதார்த்த தேதி"},
      medical:{label:"மருத்துவம்",desc:"அறுவை சிகிச்சை அல்லது சிகிச்சை தொடக்கம்"},
      education:{label:"கல்வி",desc:"வித்யாரம்பம் அல்லது புதிய பாடம்"},
      property:{label:"வீடு / சொத்து",desc:"கிரகப் பிரவேசம் அல்லது வாங்குதல்"},
    },
  },
  kn: {
    heading:"ಮುಹೂರ್ತ", subtitle:"ನಿಮ್ಮ ಕಾರ್ಯಕ್ಕೆ ದಿನ ಶುಭವೇ ಎಂದು ತಿಳಿಯಿರಿ — ವಾರ, ತಿಥಿ, ನಕ್ಷತ್ರ, ಯೋಗ, ಕರಣ ಆಧಾರದಲ್ಲಿ.",
    chooseActivity:"ಚಟುವಟಿಕೆ ಆಯ್ಕೆಮಾಡಿ", checkDate:"ದಿನ ಪರಿಶೀಲಿಸಿ",
    consulting:"ಪಂಚಾಂಗ ನೋಡುತ್ತಿದ್ದೇವೆ…",
    findBest:"✨ ಮುಂದಿನ 30 ದಿನಗಳ ಶುಭ ದಿನಗಳು →", bestHeader:"ಮುಂದಿನ 30 ದಿನಗಳ ಶುಭ ದಿನಗಳು",
    scanning:"ಕ್ಯಾಲೆಂಡರ್ ಸ್ಕ್ಯಾನ್ ಮಾಡುತ್ತಿದ್ದೇವೆ…",
    noDateFound:"ಈ ಚಟುವಟಿಕೆಗೆ ಮುಂದಿನ 30 ದಿನಗಳಲ್ಲಿ ಶುಭ ದಿನಗಳು ಕಂಡುಬರಲಿಲ್ಲ.", backToCheck:"← ದಿನ ಪರಿಶೀಲನೆಗೆ ಹಿಂದೆ",
    rahuKalam:"ರಾಹು ಕಾಲ", avoidBetween:"ಈ ಸಮಯದಲ್ಲಿ ಹೊಸ ಕೆಲಸ ಪ್ರಾರಂಭಿಸಬೇಡಿ", today:"ಇಂದು",
    vara:"ವಾರ", tithi:"ತಿಥಿ", nakshatra:"ನಕ್ಷತ್ರ", yoga:"ಯೋಗ",
    disclaimer:"ಮುಹೂರ್ತ ಸ್ಕೋರ್ ವಾರ, ತಿಥಿ, ನಕ್ಷತ್ರ, ಯೋಗ, ಕರಣ ಆಧಾರಿತ. ವಿವಾಹ ಮುಂತಾದ ನಿರ್ಧಾರಗಳಿಗೆ ಜ್ಯೋತಿಷರನ್ನು ಸಂಪರ್ಕಿಸಿ.",
    excellent:"ಉತ್ತಮ", good:"ಶುಭ", neutral:"ಸಾಮಾನ್ಯ", avoid:"ತಪ್ಪಿಸಿ",
    activities:{
      travel:{label:"ಪ್ರಯಾಣ",desc:"ರಸ್ತೆ, ರೈಲು ಅಥವಾ ವಿಮಾನ"},
      interview:{label:"ಉದ್ಯೋಗ / ಸಂದರ್ಶನ",desc:"ವೃತ್ತಿ ನಿರ್ಧಾರ ಅಥವಾ ಮೊದಲ ದಿನ"},
      business:{label:"ಹೊಸ ವ್ಯಾಪಾರ",desc:"ವ್ಯವಹಾರ ಆರಂಭ ಅಥವಾ ಒಪ್ಪಂದ"},
      marriage:{label:"ವಿವಾಹ",desc:"ಮದುವೆ ಅಥವಾ ನಿಶ್ಚಿತಾರ್ಥ"},
      medical:{label:"ವೈದ್ಯಕೀಯ",desc:"ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ ಅಥವಾ ಚಿಕಿತ್ಸೆ ಆರಂಭ"},
      education:{label:"ವಿದ್ಯಾರಂಭ",desc:"ವಿದ್ಯಾರಂಭ ಅಥವಾ ಹೊಸ ಕೋರ್ಸ್"},
      property:{label:"ಗೃಹ ಪ್ರವೇಶ",desc:"ಗೃಹ ಪ್ರವೇಶ ಅಥವಾ ಖರೀದಿ"},
    },
  },
  mr: {
    heading:"मुहूर्त", subtitle:"आपल्या कार्यासाठी तिथी शुभ आहे का ते पाहा — वार, तिथी, नक्षत्र, योग आणि करण यांवर आधारित.",
    chooseActivity:"कार्य निवडा", checkDate:"तिथी तपासा",
    consulting:"पंचांग पाहत आहोत…",
    findBest:"✨ पुढील ३० दिवसांत शुभ तिथी →", bestHeader:"पुढील ३० दिवसांतील शुभ तिथी",
    scanning:"दिनदर्शिका स्कॅन होत आहे…",
    noDateFound:"या कार्यासाठी पुढील ३० दिवसांत शुभ तिथी आढळल्या नाहीत.", backToCheck:"← तिथी तपासणीस परत",
    rahuKalam:"राहू काळ", avoidBetween:"या वेळी नवीन काम सुरू करू नका", today:"आज",
    vara:"वार", tithi:"तिथी", nakshatra:"नक्षत्र", yoga:"योग",
    disclaimer:"मुहूर्त स्कोर वार, तिथी, नक्षत्र, योग आणि करण यांवर आधारित. विवाह यांसारख्या निर्णयांसाठी ज्योतिषाचा सल्ला घ्या.",
    excellent:"उत्कृष्ट", good:"शुभ", neutral:"सामान्य", avoid:"टाळा",
    activities:{
      travel:{label:"प्रवास",desc:"रस्ता, रेल्वे किंवा विमान प्रवास"},
      interview:{label:"नोकरी / मुलाखत",desc:"करिअर निर्णय किंवा पहिला दिवस"},
      business:{label:"नवीन व्यवसाय",desc:"व्यवसाय सुरुवात किंवा करार"},
      marriage:{label:"विवाह",desc:"लग्न किंवा साखरपुडा"},
      medical:{label:"वैद्यकीय",desc:"शस्त्रक्रिया किंवा उपचार सुरुवात"},
      education:{label:"विद्यारंभ",desc:"विद्यारंभ किंवा नवीन अभ्यासक्रम"},
      property:{label:"गृहप्रवेश",desc:"गृहप्रवेश किंवा खरेदी"},
    },
  },
  en: {
    heading:"Muhurta", subtitle:"Check if a date is auspicious for your activity — based on Vara, Tithi, Nakshatra, Yoga and Karana.",
    chooseActivity:"Choose Activity", checkDate:"Check Date",
    consulting:"Consulting the Panchang…",
    findBest:"✨ Find Best Dates in Next 30 Days →", bestHeader:"BEST DATES IN NEXT 30 DAYS",
    scanning:"Scanning the calendar…",
    noDateFound:"No strongly auspicious dates found in the next 30 days. Try checking individual dates above.", backToCheck:"← Back to date check",
    rahuKalam:"Rahu Kalam", avoidBetween:"Avoid starting anything during this window", today:"today",
    vara:"Vara", tithi:"Tithi", nakshatra:"Nakshatra", yoga:"Yoga",
    disclaimer:"Muhurta scoring uses Vara, Tithi, Nakshatra, Yoga and Karana calculated astronomically. Rahu Kalam uses actual sunrise/sunset. Always consult a jyotishi for critical decisions like marriage or surgery.",
    excellent:"Excellent", good:"Good", neutral:"Neutral", avoid:"Avoid",
    activities:{
      travel:{label:"Travel",desc:"Journey by road, train or flight"},
      interview:{label:"Job / Interview",desc:"Career decision or first day"},
      business:{label:"New Venture",desc:"Business launch or contract signing"},
      marriage:{label:"Marriage",desc:"Wedding or engagement date"},
      medical:{label:"Medical",desc:"Surgery or starting treatment"},
      education:{label:"Education",desc:"Vidyarambham or new course"},
      property:{label:"Property",desc:"Griha pravesham or purchase"},
    },
  },
};

const VARA_EN_IDX = { Sunday:0, Monday:1, Tuesday:2, Wednesday:3, Thursday:4, Friday:5, Saturday:6 };
function tVara(enName, lang) {
  if (!enName || lang === "en") return enName;
  const idx = VARA_EN_IDX[enName];
  if (idx === undefined) return enName;
  return LANG[lang]?.vara[idx] || enName;
}

// ── Helpers ───────────────────────────────────────────────────────────────────
function tr(enName, lang, table) {
  if (!enName) return "";
  if (lang === "te" || lang === "en") return enName; // caller handles te/_en fields
  return (table[lang] && table[lang][enName]) || enName;
}

// Get tithi name for given lang (uses flat month-data fields OR name_en from today-data)
function tTithi(enName, teName, lang) {
  if (lang === "te") return teName;
  if (lang === "en") return enName;
  return tr(enName, lang, TITHI_TRANS);
}
function tNak(enName, teName, lang) {
  if (lang === "te") return teName;
  if (lang === "en") return enName;
  return tr(enName, lang, NAK_TRANS);
}
function tYoga(enName, teName, lang) {
  if (lang === "te") return teName;
  if (lang === "en") return enName;
  return tr(enName, lang, YOGA_TRANS);
}
function tKarana(enName, teName, lang) {
  if (lang === "te") return teName;
  if (lang === "en") return enName;
  return tr(enName, lang, KARANA_TRANS);
}
function tPaksha(paksha_en, lang) {
  return LANG[lang].paksha[paksha_en] || paksha_en;
}
function tMasa(masa, lang) {
  if (!masa) return "";
  if (lang === "te") return masa.name_te;
  const idx = (masa.index || 1) - 1;
  return LANG[lang].masa[idx] || masa.name_en;
}

// ── Design tokens (white-premium system) ──────────────────────────────────────
// Plain sans-serif everywhere text must be read; decorative fonts are not used
// on functional UI. `TXT` holds WCAG-legible (darker) shades of each accent —
// bright/pastel hexes stay reserved for icons, small badges, and borders,
// never for card backgrounds or sentence-length text.
const font = { title: "'Inter',sans-serif", body: "'Inter',sans-serif" };
// Inter has no Telugu/Tamil/Kannada/Devanagari glyphs — without an explicit
// regional font, that text silently falls back to a thin OS default and
// reads dull next to Inter UI chrome. Use this for any translated content.
const regionalFont = (lang) => ({
  te: "'Noto Sans Telugu','Inter',sans-serif",
  ta: "'Noto Sans Tamil','Inter',sans-serif",
  kn: "'Noto Sans Kannada','Inter',sans-serif",
  hi: "'Noto Sans Devanagari','Inter',sans-serif",
  mr: "'Noto Sans Devanagari','Inter',sans-serif",
}[lang] || font.body);
const TXT = {
  saffron:"#B5591F", gold:"#8A6A22", indigo:"#4338CA", emerald:"#047857",
  green:"#15803D", lime:"#4D7C0F", amber:"#B45309", orange:"#C2410C",
  red:"#B91C1C", purple:"#7E22CE",
};
// Section-heading style — bigger + a soft saffron glow, matching the
// SectionTitle treatment already used on other white-premium pages.
const sectionTitleStyle = (lang) => ({
  fontFamily:regionalFont(lang), fontSize:"1.3rem", fontWeight:800,
  color:"var(--saffron)", marginBottom:"14px",
  textShadow:"0 0 20px rgba(232,131,42,0.18)",
});

function dayStyle(d) {
  if (d.festival)    return { bg:"var(--bg2)", border:"var(--border)", badge:TXT.saffron, label:"🎉" };
  if (d.is_purnima)  return { bg:"var(--bg2)", border:"var(--border)", badge:TXT.gold,     label:"🌕" };
  if (d.is_amavasya) return { bg:"var(--bg2)", border:"var(--border)", badge:TXT.indigo,   label:"🌑" };
  if (d.is_ekadashi) return { bg:"var(--bg2)", border:"var(--border)", badge:TXT.emerald,  label:"🌿" };
  return { bg:"var(--bg2)", border:"var(--border)", badge:"var(--text-dim)", label:null };
}

// ── Language chip selector ────────────────────────────────────────────────────
function LangSelector({ lang, onChange }) {
  return (
    <div style={{ display:"flex", gap:"6px", flexWrap:"wrap", marginBottom:"20px" }}>
      {["te","hi","ta","kn","mr","en"].map(l => (
        <button key={l} onClick={() => onChange(l)} style={{
          background: lang === l ? "var(--saffron)" : "var(--bg2)",
          color: lang === l ? "#FFFFFF" : "var(--text-dim)",
          border: `1px solid ${lang === l ? "var(--saffron)" : "var(--border)"}`,
          borderRadius: "20px", padding: "6px 15px",
          fontFamily: font.body, fontSize: "1.0rem",
          fontWeight: lang === l ? 700 : 500,
          cursor: "pointer", transition: "all 0.15s",
          boxShadow: lang === l ? "0 2px 10px rgba(232,131,42,0.3)" : "none",
        }}>
          {LANG[l].chip}
        </button>
      ))}
    </div>
  );
}

const TIMING_LABELS = {
  te: { header:"ఈరోజు సమయాలు", sunrise:"సూర్యోదయం", sunset:"సూర్యాస్తమయం", rahu:"రాహు కాలం", yama:"యమగంఢం", gulika:"గుళిక కాలం", avoid:"కొత్త పనులు వద్దు" },
  hi: { header:"आज के समय",    sunrise:"सूर्योदय",    sunset:"सूर्यास्त",       rahu:"राहु काल",  yama:"यमगण्ड",   gulika:"गुलिक काल",  avoid:"नया काम न करें" },
  ta: { header:"இன்றைய நேரங்கள்", sunrise:"சூரிய உதயம்", sunset:"சூரிய அஸ்தமனம்", rahu:"ராகு காலம்",yama:"யமகண்டம்", gulika:"குளிக காலம்",avoid:"புதிய வேலை வேண்டாம்" },
  kn: { header:"ಇಂದಿನ ಸಮಯಗಳು", sunrise:"ಸೂರ್ಯೋದಯ",   sunset:"ಸೂರ್ಯಾಸ್ತ",      rahu:"ರಾಹು ಕಾಲ",  yama:"ಯಮಗಂಡ",    gulika:"ಗುಳಿಕ ಕಾಲ",  avoid:"ಹೊಸ ಕೆಲಸ ಬೇಡ" },
  mr: { header:"आजचे वेळ",     sunrise:"सूर्योदय",    sunset:"सूर्यास्त",       rahu:"राहु काल",  yama:"यमगंड",    gulika:"गुलिक काल",  avoid:"नवीन काम नको" },
  en: { header:"Today's Timings", sunrise:"Sunrise",   sunset:"Sunset",           rahu:"Rahu Kalam",yama:"Yamagandam",gulika:"Gulika Kalam",avoid:"avoid new work" },
};

// ── Daily timings strip (Rahu Kalam / Yamagandam / Gulika) ───────────────────
function DailyTimingsStrip({ lang }) {
  const [timings, setTimings] = useState(null);

  useEffect(() => {
    fetch(`${API}/panchang/daily-timings`)
      .then(r => r.json())
      .then(d => setTimings(d))
      .catch(() => {});
  }, []);

  if (!timings) return null;

  const TL = TIMING_LABELS[lang] || TIMING_LABELS.te;

  const items = [
    { label:TL.sunrise, icon:"🌅", value:timings.sunrise,                                            color:TXT.amber },
    { label:TL.sunset,  icon:"🌇", value:timings.sunset,                                             color:TXT.orange },
    { label:TL.rahu,    icon:"🚫", value:`${timings.rahu_kalam.start}–${timings.rahu_kalam.end}`,    color:TXT.red },
    { label:TL.yama,    icon:"⚠️", value:`${timings.yamagandam.start}–${timings.yamagandam.end}`,    color:TXT.orange },
    { label:TL.gulika,  icon:"🔴", value:`${timings.gulika_kalam.start}–${timings.gulika_kalam.end}`,color:TXT.purple },
  ];

  return (
    <div style={{ marginBottom:"16px" }}>
      <div style={sectionTitleStyle(lang)}>
        ⏰ {TL.header}
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px" }}>
        {/* Sunrise + Sunset side by side */}
        {items.slice(0,2).map((item,i) => (
          <div key={i} style={{ background:"var(--bg2)", border:"1px solid var(--border)",
            borderRadius:"14px", padding:"14px 16px", display:"flex", alignItems:"center", gap:"12px" }}>
            <span style={{ fontSize:"1.8rem" }}>{item.icon}</span>
            <div>
              <div style={{ fontSize:"1.1rem", color:"var(--text)", fontFamily:regionalFont(lang),
                fontWeight:700, marginBottom:"3px" }}>{item.label}</div>
              <div style={{ fontSize:"1.2rem", color:item.color, fontWeight:700, letterSpacing:"0.03em" }}>{item.value}</div>
            </div>
          </div>
        ))}
        {/* Rahu / Yamagandam — side by side */}
        {items.slice(2,4).map((item,i) => (
          <div key={i} style={{ background:"var(--bg2)", border:"1px solid var(--border)",
            borderRadius:"14px", padding:"14px 16px" }}>
            <div style={{ display:"flex", alignItems:"center", gap:"7px", marginBottom:"6px" }}>
              <span style={{ fontSize:"1.2rem" }}>{item.icon}</span>
              <span style={{ fontSize:"1.1rem", color:"var(--text)", fontFamily:regionalFont(lang),
                fontWeight:700 }}>{item.label}</span>
            </div>
            <div style={{ fontSize:"1.1rem", color:item.color, fontWeight:700, letterSpacing:"0.03em" }}>{item.value}</div>
            <div style={{ fontSize:"1.02rem", color:"var(--text)", marginTop:"4px", fontFamily:regionalFont(lang) }}>IST · {TL.avoid}</div>
          </div>
        ))}
        {/* Gulika — full width */}
        {items[4] && (() => { const item = items[4]; return (
          <div style={{ gridColumn:"span 2", background:"var(--bg2)", border:"1px solid var(--border)",
            borderRadius:"14px", padding:"14px 18px", display:"flex", alignItems:"center", gap:"16px" }}>
            <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
              <span style={{ fontSize:"1.2rem" }}>{item.icon}</span>
              <span style={{ fontSize:"1.1rem", color:"var(--text)", fontFamily:regionalFont(lang),
                fontWeight:700 }}>{item.label}</span>
            </div>
            <div style={{ fontSize:"1.1rem", color:item.color, fontWeight:700, letterSpacing:"0.03em" }}>{item.value}</div>
            <div style={{ fontSize:"1.02rem", color:"var(--text)", marginLeft:"auto", fontFamily:regionalFont(lang) }}>IST · {TL.avoid}</div>
          </div>
        ); })()}
      </div>
    </div>
  );
}

// ── Today's panchang banner ───────────────────────────────────────────────────
function TodayBanner({ data, lang }) {
  if (!data) return null;
  const L    = LANG[lang];
  const vara = data.vara;
  const tithi     = data.tithi;
  const nakshatra = data.nakshatra;
  const yoga      = data.yoga;
  const karana    = data.karana;
  const masa      = data.masa;

  const tithiName  = tTithi(tithi.name_en, tithi.name_te, lang);
  const nakName    = tNak(nakshatra.name_en, nakshatra.name_te, lang);
  const yogaName   = tYoga(yoga.name_en, yoga.name_te, lang);
  const karanaName = tKarana(karana.name_en, karana.name_te, lang);
  const masaName   = tMasa(masa, lang);
  const paksha     = tPaksha(tithi.paksha_en, lang);
  const varaName   = lang === "te" ? vara.name_te : L.vara[vara.index];
  const deityName  = lang === "te" ? vara.deity_te : L.deity[vara.index];

  return (
    <div style={{
      background: "var(--bg2)",
      border: "1px solid var(--border)", borderRadius: "18px",
      overflow: "hidden", marginBottom: "20px",
      boxShadow: "var(--card-shadow)",
    }}>
      <div style={{ height:"3px", background:"var(--saffron)" }} />

      {/* Header */}
      <div style={{ padding:"18px 20px 14px", display:"flex", alignItems:"center",
        justifyContent:"space-between", borderBottom:"1px solid var(--border)" }}>
        <div>
          <div style={{ fontFamily:regionalFont(lang), fontSize:"1.1rem",
            color:"var(--saffron)", fontWeight:700, marginBottom:"5px" }}>
            {L.todayHeader}
          </div>
          <div style={{ fontSize:"1.08rem", color:"var(--text)", fontFamily:regionalFont(lang) }}>
            {masaName} {L.monthLabel} · {paksha}
          </div>
        </div>
        {/* Vara chip */}
        <div style={{ background:"var(--bg3)", border:"1px solid var(--border)",
          borderRadius:"14px", padding:"8px 16px", textAlign:"center", minWidth:"72px" }}>
          <div style={{ fontFamily:regionalFont(lang), fontSize:"1.1rem", fontWeight:700, color:vara.color, lineHeight:1.2 }}>
            {varaName}
          </div>
          <div style={{ fontSize:"1.05rem", color:"var(--text)", marginTop:"2px", fontFamily:regionalFont(lang) }}>{deityName}</div>
        </div>
      </div>

      {/* Festival banner */}
      {data.festival && (
        <div style={{ padding:"10px 20px", background:"var(--bg3)",
          borderBottom:"1px solid var(--border)", display:"flex", alignItems:"center", gap:"8px" }}>
          <span style={{ fontSize:"1.1rem" }}>🎉</span>
          <div>
            <div style={{ fontFamily:regionalFont(lang), fontSize:"1.08rem", fontWeight:700, color:"var(--saffron)" }}>
              {data.festival[`name_${lang}`] || data.festival.name}
            </div>
            {data.festival.deity && (
              <div style={{ fontSize:"1.05rem", color:"var(--text)", fontFamily:regionalFont(lang) }}>{data.festival.deity}</div>
            )}
          </div>
        </div>
      )}

      {/* Five limbs grid */}
      <div style={{ padding:"16px 20px 12px", display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px" }}>
        {[
          { label:L.tithiLbl,     value:tithiName,  sub:paksha,       emoji:"🌙" },
          { label:L.nakshatraLbl, value:nakName,     sub:`${nakshatra.pct}%`, emoji:"⭐" },
          { label:L.yogaLbl,      value:yogaName,
            sub: yoga.is_good ? L.auspicious : yoga.is_bad ? L.inauspicious : "",
            emoji: yoga.is_good ? "✨" : yoga.is_bad ? "⚠️" : "🔸",
            accent: yoga.is_good ? TXT.emerald : yoga.is_bad ? TXT.red : null },
          { label:L.karanaLbl,    value:karanaName,
            sub: karana.is_vishti ? L.bhadra : "",
            emoji: karana.is_vishti ? "⚠️" : "🔹",
            accent: karana.is_vishti ? TXT.red : null },
        ].map((item, i) => (
          <div key={i} style={{
            background: "var(--bg2)",
            border: "1px solid var(--border)",
            borderRadius:"12px", padding:"13px 15px",
          }}>
            <div style={{ fontSize:"1.08rem", color:"var(--text)", marginBottom:"5px",
              display:"flex", alignItems:"center", gap:"5px", fontFamily:regionalFont(lang), fontWeight:600 }}>
              <span>{item.emoji}</span>
              <span>{item.label}</span>
            </div>
            <div style={{ fontFamily:regionalFont(lang), fontSize:"1.25rem", fontWeight:700,
              color:item.accent || "var(--text)", lineHeight:1.2 }}>
              {item.value}
            </div>
            {item.sub && (
              <div style={{ fontSize:"1.05rem", color:item.accent || "var(--text)", marginTop:"3px",
                fontFamily:regionalFont(lang) }}>
                {item.sub}
              </div>
            )}
          </div>
        ))}
      </div>

      {!data.has_accurate_calc && (
        <div style={{ padding:"6px 20px 12px", fontSize:"1.0rem", color:"var(--text-dim)" }}>
          * Approximate calculations · install pyswisseph for precise panchang
        </div>
      )}

      {/* Daily inauspicious timings */}
      <div style={{ borderTop:"1px solid var(--border)", padding:"16px 20px 18px" }}>
        <DailyTimingsStrip lang={lang} />
      </div>
    </div>
  );
}

// ── Month calendar grid ───────────────────────────────────────────────────────
function MonthCalendar({ monthData, selectedDay, onSelectDay, lang }) {
  if (!monthData.length) return null;
  const L = LANG[lang];
  const firstWeekday = monthData[0].weekday;

  return (
    <div style={{ width:"100%", boxSizing:"border-box" }}>
      {/* Day-of-week headers */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:"4px", marginBottom:"8px" }}>
        {L.dow.map((d, i) => (
          <div key={i} style={{
            textAlign:"center", fontSize:"1.05rem",
            color: i===0 ? TXT.red : i===6 ? TXT.indigo : "var(--text)",
            padding:"6px 0", fontWeight:700,
            background:"var(--bg3)", borderRadius:"6px",
            fontFamily:regionalFont(lang),
          }}>{d}</div>
        ))}
      </div>

      {/* Calendar cells */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:"4px" }}>
        {Array.from({ length: firstWeekday }, (_, i) => <div key={`e${i}`} />)}

        {monthData.map(d => {
          const sty = dayStyle(d);
          const isToday    = d.date === new Date().toISOString().split("T")[0];
          const isSelected = selectedDay?.date === d.date;
          const tithiLabel = tTithi(d.tithi_en, d.tithi_te, lang);
          const festivalShort = d.festival
            ? d.festival.split(" ").slice(0,2).join(" ")
            : null;

          return (
            <div key={d.day} onClick={() => onSelectDay(d)} style={{
              background: isSelected
                ? "rgba(232,131,42,0.14)"
                : isToday
                  ? "rgba(232,131,42,0.07)"
                  : sty.bg,
              border: `1.5px solid ${isSelected || isToday ? "var(--saffron)" : sty.border}`,
              borderRadius:"10px", padding:"8px 4px 6px",
              cursor:"pointer", transition:"all 0.15s", minHeight:"92px",
              display:"flex", flexDirection:"column", alignItems:"center",
              position:"relative",
            }}
            onMouseEnter={e => { if (!isSelected) { e.currentTarget.style.borderColor="var(--saffron)"; e.currentTarget.style.background="rgba(232,131,42,0.06)"; }}}
            onMouseLeave={e => { if (!isSelected) { e.currentTarget.style.borderColor= isToday ? "var(--saffron)" : sty.border; e.currentTarget.style.background= isToday ? "rgba(232,131,42,0.07)" : sty.bg; }}}
            >
              {/* Today dot */}
              {isToday && (
                <div style={{ position:"absolute", top:4, right:4,
                  width:5, height:5, borderRadius:"50%", background:"var(--saffron)" }} />
              )}

              {/* Day number */}
              <div style={{
                fontSize:"1.05rem", fontWeight:700, lineHeight:1,
                color: d.weekday===0 ? TXT.red : d.weekday===6 ? TXT.indigo : isToday ? "var(--saffron)" : "var(--text)",
                marginBottom:"5px",
                fontFamily:font.title,
              }}>
                {d.day}
              </div>

              {/* Tithi / festival name */}
              <div style={{
                fontSize:"1.0rem", color: sty.label ? sty.badge : "var(--text)",
                textAlign:"center", lineHeight:1.35, width:"100%",
                overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap",
                paddingLeft:"2px", paddingRight:"2px",
                fontWeight: sty.label ? 700 : 500,
                fontFamily:regionalFont(lang),
              }}>
                {festivalShort || tithiLabel}
              </div>

              {/* Special day badge */}
              {sty.label && (
                <div style={{ fontSize:"1.0rem", marginTop:"3px", lineHeight:1 }}>{sty.label}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── Day detail panel ──────────────────────────────────────────────────────────
function DayDetail({ day, lang, onClose }) {
  if (!day) return null;
  const L   = LANG[lang];
  const sty = dayStyle(day);
  const dateObj = new Date(day.date + "T00:00:00");

  const tithiName  = tTithi(day.tithi_en, day.tithi_te, lang);
  const nakName    = tNak(day.nak_en, day.nak_te, lang);
  const yogaName   = tYoga(day.yoga_en, day.yoga_te, lang);
  const varaName   = L.vara[day.weekday];
  const paksha     = day.paksha_en ? tPaksha(day.paksha_en, lang) : (lang === "te" ? day.paksha_te : "");

  return (
    <div style={{
      background: "var(--bg2)",
      border: "1px solid var(--border)", borderRadius:"16px",
      padding:"20px", marginTop:"16px", boxShadow:"var(--card-shadow)",
    }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:"14px" }}>
        <div>
          <div style={{ fontFamily:font.title, fontSize:"1.1rem", fontWeight:700,
            color:"var(--saffron)", marginBottom:"2px" }}>
            {dateObj.toLocaleDateString("en-IN", { day:"numeric", month:"long", year:"numeric" })}
          </div>
          <div style={{ fontSize:"1.0rem", color:"var(--text-dim)", fontFamily:regionalFont(lang), fontWeight:500 }}>
            {varaName}{paksha ? ` · ${paksha}` : ""}
          </div>
        </div>
        <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer",
          color:"var(--text-dim)", fontSize:"1.4rem", padding:"0", lineHeight:1 }}>×</button>
      </div>

      {day.festival && (
        <div style={{ padding:"8px 12px", background:"var(--bg3)", border:"1px solid var(--border)",
          borderRadius:"8px", marginBottom:"12px" }}>
          <span style={{ fontSize:"1.0rem", color:"var(--saffron)", fontWeight:600, fontFamily:regionalFont(lang) }}>🎉 {day.festival}</span>
        </div>
      )}

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px" }}>
        {[
          { label:L.tithiLbl,     value:tithiName },
          { label:L.nakshatraLbl, value:nakName },
          { label:L.yogaLbl,      value:yogaName },
          { label:L.varaLbl,      value:varaName },
        ].map((item, i) => (
          <div key={i} style={{ background:"var(--bg3)", border:"1px solid var(--border)", borderRadius:"8px", padding:"10px 12px" }}>
            <div style={{ fontSize:"1.0rem", color:"var(--text-dim)", marginBottom:"3px", fontFamily:regionalFont(lang) }}>{item.label}</div>
            <div style={{ fontSize:"1.0rem", color:"var(--text)", fontFamily:regionalFont(lang), fontWeight:600 }}>{item.value}</div>
          </div>
        ))}
      </div>

      {(day.is_ekadashi || day.is_purnima || day.is_amavasya) && (
        <div style={{ marginTop:"12px", padding:"10px 14px", background:"var(--bg3)", border:"1px solid var(--border)",
          borderRadius:"8px", fontSize:"1.0rem", color:"var(--text)", lineHeight:1.6, fontFamily:regionalFont(lang), fontWeight:500 }}>
          {day.is_ekadashi && <div>{L.ekadashiGuide}</div>}
          {day.is_purnima  && <div>{L.purnimaGuide}</div>}
          {day.is_amavasya && <div>{L.amaavasyaGuide}</div>}
        </div>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// ── Muhurta Section ───────────────────────────────────────────────────────────

const ACTIVITY_ICONS = {
  travel:"✈️", interview:"💼", business:"🏢", marriage:"💍",
  medical:"🏥", education:"📚", property:"🏠",
};

// VERDICT_COLOR: saturated hues for borders/rings/decorative dots (non-text uses).
// VERDICT_TEXT: darker, WCAG-legible shades — always used when the verdict
// color sits behind or on top of text the user must read.
const VERDICT_COLOR = { Excellent:"#22c55e", Good:"#84cc16", Neutral:"#f59e0b", Avoid:"#ef4444" };
const VERDICT_TEXT  = { Excellent:TXT.green, Good:TXT.lime, Neutral:TXT.amber, Avoid:TXT.red };

function ScoreRing({ score, color, textColor }) {
  const r = 30, circ = 2 * Math.PI * r;
  const filled = (score / 100) * circ;
  return (
    <svg width={76} height={76} style={{ flexShrink:0 }}>
      <circle cx={38} cy={38} r={r} fill="none" stroke="var(--border)" strokeWidth={5} />
      <circle cx={38} cy={38} r={r} fill="none" stroke={color} strokeWidth={5}
        strokeDasharray={`${filled} ${circ}`}
        strokeLinecap="round"
        transform="rotate(-90 38 38)" />
      <text x={38} y={43} textAnchor="middle"
        style={{ fontSize:"1rem", fontWeight:700, fill:textColor || color }}>{score}</text>
    </svg>
  );
}

function MuhurtaSection({ lang }) {
  const ML = MUHURTA_LANG[lang] || MUHURTA_LANG.en;
  const today = new Date().toISOString().slice(0,10);
  const [activity,    setActivity]    = useState(null);
  const [date,        setDate]        = useState(today);
  const [result,      setResult]      = useState(null);
  const [bestDates,   setBestDates]   = useState([]);
  const [loading,     setLoading]     = useState(false);
  const [bestLoading, setBestLoading] = useState(false);
  const [showBest,    setShowBest]    = useState(false);

  const check = async (act, d) => {
    const a = act || activity;
    const dt = d || date;
    if (!a) return;
    setLoading(true); setResult(null); setShowBest(false);
    try {
      const res = await fetch(`${API}/muhurta/check?activity=${a}&date=${dt}`);
      setResult(await res.json());
    } catch {}
    setLoading(false);
  };

  const findBest = async () => {
    if (!activity) return;
    setBestLoading(true); setShowBest(true);
    try {
      const res = await fetch(`${API}/muhurta/best-dates?activity=${activity}&days=30`);
      const d = await res.json();
      setBestDates(d.dates || []);
    } catch {}
    setBestLoading(false);
  };

  const selectActivity = (id) => {
    setActivity(id); setResult(null); setShowBest(false);
    check(id, date);
  };

  const handleDateChange = (e) => {
    setDate(e.target.value);
    if (activity) check(activity, e.target.value);
  };

  const verdictLabel = (v) => ML[v?.toLowerCase()] || v;

  return (
    <div style={{ animation:"fadeInUp 0.3s ease" }}>
      {/* Header */}
      <div style={{ marginBottom:"28px" }}>
        <div style={{ ...sectionTitleStyle(lang), fontSize:"1.4rem", marginBottom:"8px" }}>
          ⏰ {ML.heading}
        </div>
        <div style={{ fontSize:"1rem", color:"var(--text)", lineHeight:1.8,
          fontFamily:regionalFont(lang) }}>
          {ML.subtitle}
        </div>
      </div>

      {/* Activity grid */}
      <div style={{ fontSize:"1.15rem", color:"var(--text)",
        marginBottom:"14px", fontWeight:800, fontFamily:regionalFont(lang) }}>
        {ML.chooseActivity}
      </div>
      <div className="muhurta-activity-grid" style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)",
        gap:"14px", marginBottom:"28px" }}>
        {Object.entries(ML.activities).map(([id, act]) => (
          <div key={id} onClick={() => selectActivity(id)} style={{
            background: activity === id ? "rgba(232,131,42,0.10)" : "var(--bg2)",
            border:`1.5px solid ${activity === id ? "var(--saffron)" : "var(--border)"}`,
            borderRadius:"18px", padding:"20px 10px", cursor:"pointer",
            transition:"all 0.2s", textAlign:"center",
            boxShadow: activity === id ? "0 4px 16px rgba(232,131,42,0.15)" : "var(--card-shadow)",
            display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center",
            minHeight:"140px",
          }}>
            <div style={{ fontSize:"2rem", marginBottom:"10px" }}>{ACTIVITY_ICONS[id]}</div>
            <div style={{ fontSize:"1.1rem", color:"var(--text)",
              fontWeight:800, marginBottom:"6px", lineHeight:1.3,
              fontFamily:regionalFont(lang) }}>{act.label}</div>
            <div style={{ fontSize:"1.08rem", color:"var(--text)",
              lineHeight:1.5, fontFamily:regionalFont(lang) }}>{act.desc}</div>
          </div>
        ))}
      </div>

      {/* Date picker */}
      {activity && (
        <div style={{ marginBottom:"24px" }}>
          <div style={{ fontSize:"1.15rem", color:"var(--text)",
            marginBottom:"10px", fontWeight:800, fontFamily:regionalFont(lang) }}>
            {ML.checkDate}
          </div>
          <input type="date" value={date} onChange={handleDateChange}
            min={today}
            style={{ background:"var(--bg2)", border:"1.5px solid var(--border)",
              borderRadius:"12px", padding:"12px 16px", color:"var(--text)",
              fontSize:"1rem", width:"100%", boxSizing:"border-box" }} />
        </div>
      )}

      {/* Loading */}
      {loading && (
        <div style={{ textAlign:"center", padding:"32px", color:"var(--text)",
          fontSize:"1.1rem", fontFamily:regionalFont(lang) }}>{ML.consulting}</div>
      )}

      {/* Result card */}
      {result && !loading && (
        <div style={{
          background: "var(--bg2)",
          border:`2px solid ${VERDICT_COLOR[result.verdict] || "var(--border)"}`,
          borderRadius:"20px", padding:"22px", marginBottom:"16px",
          boxShadow:"var(--card-shadow)",
          animation:"fadeInUp 0.3s ease",
        }}>
          {/* Score + verdict */}
          <div style={{ display:"flex", alignItems:"center", gap:"20px", marginBottom:"20px" }}>
            <ScoreRing score={result.score} color={VERDICT_COLOR[result.verdict]} textColor={VERDICT_TEXT[result.verdict]} />
            <div>
              <div style={{ fontFamily:regionalFont(lang), fontSize:"1.5rem", fontWeight:700,
                color: VERDICT_TEXT[result.verdict], marginBottom:"5px" }}>
                {verdictLabel(result.verdict)}
              </div>
              <div style={{ fontSize:"1.1rem", color:"var(--text)", fontFamily:regionalFont(lang) }}>
                {new Date(result.date + "T00:00:00").toLocaleDateString(
                  LANG_LOCALE[lang] || "en-IN",
                  { weekday:"long", day:"numeric", month:"long", year:"numeric" })}
              </div>
            </div>
          </div>

          {/* Panchang summary */}
          <div style={{ display:"flex", flexWrap:"wrap", gap:"8px", marginBottom:"18px" }}>
            {[
              { label:ML.vara,      val:tVara(result.panchang?.vara, lang) },
              { label:ML.tithi,     val:`${tTithi(result.panchang?.tithi, result.panchang?.tithi_te, lang)} · ${(tPaksha(result.panchang?.paksha, lang) || "").split(" ")[0]}` },
              { label:ML.nakshatra, val:tNak(result.panchang?.nakshatra, result.panchang?.nak_te, lang) },
              { label:ML.yoga,      val:tYoga(result.panchang?.yoga, result.panchang?.yoga_te, lang) },
            ].map(item => (
              <div key={item.label} style={{ background:"var(--bg3)", border:"1px solid var(--border)",
                borderRadius:"10px", padding:"8px 16px", fontSize:"1.1rem", fontFamily:regionalFont(lang) }}>
                <span style={{ color:"var(--text-dim)" }}>{item.label}: </span>
                <span style={{ color:"var(--text)", fontWeight:700 }}>{item.val}</span>
              </div>
            ))}
          </div>

          {/* Positives */}
          {result.positives?.length > 0 && (
            <div style={{ marginBottom:"14px" }}>
              {result.positives.map((p, i) => (
                <div key={i} style={{ display:"flex", gap:"10px", marginBottom:"10px",
                  fontSize:"1.12rem", color:"var(--text)", lineHeight:1.7, fontFamily:regionalFont(lang), fontWeight:500 }}>
                  <span style={{ color:TXT.green, flexShrink:0, fontSize:"1.1rem", fontWeight:700 }}>✓</span> {formatMsg(p, lang)}
                </div>
              ))}
            </div>
          )}

          {/* Warnings */}
          {result.warnings?.length > 0 && (
            <div style={{ marginBottom:"14px" }}>
              {result.warnings.map((w, i) => (
                <div key={i} style={{ display:"flex", gap:"10px", marginBottom:"10px",
                  fontSize:"1.12rem", color:"var(--text)", lineHeight:1.7, fontFamily:regionalFont(lang), fontWeight:500 }}>
                  <span style={{ color:TXT.amber, flexShrink:0, fontSize:"1.1rem", fontWeight:700 }}>⚠</span> {formatMsg(w, lang)}
                </div>
              ))}
            </div>
          )}

          {/* Rahu Kalam */}
          <div style={{ marginTop:"14px", padding:"14px 16px",
            background:"var(--bg3)", border:"1px solid var(--border)",
            borderRadius:"14px", fontSize:"1.1rem", color:"var(--text)", fontFamily:regionalFont(lang) }}>
            🚫 <b style={{ color:TXT.red }}>{ML.rahuKalam}:</b>{" "}
            <b style={{ color:"var(--text)" }}>
              {result.rahu_kalam?.start} – {result.rahu_kalam?.end} IST
            </b>
            <span style={{ color:"var(--text-dim)" }}>{" "}— {ML.avoidBetween}</span>
          </div>
        </div>
      )}

      {/* Find best dates button */}
      {activity && !showBest && (
        <button onClick={findBest} style={{
          width:"100%", padding:"16px", minHeight:"48px",
          background:"var(--saffron)",
          border:"none", borderRadius:"14px",
          color:"#FFFFFF", fontFamily:regionalFont(lang), fontWeight:700,
          fontSize:"1.0rem", cursor:"pointer", marginBottom:"16px",
        }}>
          {ML.findBest}
        </button>
      )}

      {/* Best dates list */}
      {showBest && (
        <div>
          <div style={sectionTitleStyle(lang)}>
            {ML.bestHeader}
          </div>
          {bestLoading && (
            <div style={{ textAlign:"center", padding:"24px", color:"var(--text-dim)",
              fontSize:"1rem", fontFamily:regionalFont(lang) }}>{ML.scanning}</div>
          )}
          {!bestLoading && bestDates.length === 0 && (
            <div style={{ textAlign:"center", padding:"24px", color:"var(--text)",
              fontSize:"1.0rem", lineHeight:1.7, fontFamily:regionalFont(lang), fontWeight:500 }}>
              {ML.noDateFound}
            </div>
          )}
          {!bestLoading && bestDates.map((d, i) => {
            const dt = new Date(d.date + "T00:00:00");
            const isExcellent = d.verdict === "Excellent";
            return (
              <div key={i} onClick={() => { setDate(d.date); setResult(d); setShowBest(false); }}
                style={{
                  display:"flex", alignItems:"center", gap:"14px",
                  background:"var(--bg2)", border:"1.5px solid var(--border)",
                  borderRadius:"14px", padding:"16px", marginBottom:"10px",
                  cursor:"pointer", transition:"all 0.2s",
                }}
                onMouseEnter={e => e.currentTarget.style.borderColor = VERDICT_COLOR[d.verdict]}
                onMouseLeave={e => e.currentTarget.style.borderColor = "var(--border)"}
              >
                <div style={{ textAlign:"center", minWidth:50 }}>
                  <div style={{ fontSize:"1.5rem", fontWeight:700,
                    color: VERDICT_TEXT[d.verdict] }}>
                    {dt.getDate()}
                  </div>
                  <div style={{ fontSize:"1.0rem", color:"var(--text-dim)", fontFamily:regionalFont(lang) }}>
                    {dt.toLocaleDateString(LANG_LOCALE[lang]||"en-IN",{month:"short"})}
                  </div>
                </div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:"1.1rem", color:"var(--text)", marginBottom:"4px", fontWeight:700, fontFamily:regionalFont(lang) }}>
                    {tVara(dt.toLocaleDateString("en-IN",{weekday:"long"}), lang)}
                    {isExcellent && <span style={{ marginLeft:"8px", fontSize:"1.0rem", fontWeight:700,
                      color:TXT.green, background:"rgba(34,197,94,0.12)",
                      padding:"2px 8px", borderRadius:"6px" }}>{ML.excellent}</span>}
                  </div>
                  <div style={{ fontSize:"1.05rem", color:"var(--text)", fontFamily:regionalFont(lang),
                    overflow:"hidden", whiteSpace:"nowrap", textOverflow:"ellipsis" }}>
                    {tNak(d.panchang?.nakshatra, d.panchang?.nak_te, lang)} · {tTithi(d.panchang?.tithi, d.panchang?.tithi_te, lang)}
                  </div>
                </div>
                <div style={{ fontSize:"1.2rem", fontWeight:700,
                  color: VERDICT_TEXT[d.verdict], flexShrink:0 }}>
                  {d.score}
                </div>
              </div>
            );
          })}
          <button onClick={() => setShowBest(false)} style={{
            background:"transparent", border:"1px solid var(--border)",
            borderRadius:"10px", padding:"10px 20px", color:"var(--text-dim)",
            fontSize:"1.0rem", cursor:"pointer", marginTop:"4px", fontFamily:regionalFont(lang),
          }}>{ML.backToCheck}</button>
        </div>
      )}

      <div style={{ marginTop:"20px", fontSize:"1.05rem", color:"var(--text-dim)",
        lineHeight:1.8, padding:"0 2px", borderTop:"1px solid var(--border)", paddingTop:"14px", fontFamily:regionalFont(lang) }}>
        {ML.disclaimer}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// MAIN PanchangPage
// ══════════════════════════════════════════════════════════════════════════════
// ── Birth date prompt for existing users ──────────────────────────────────────
function BirthDatePrompt({ userId, onSaved }) {
  const [open, setOpen] = useState(false);
  const [dob,  setDob]  = useState("");
  const [city, setCity] = useState("");
  const [saved, setSaved] = useState(false);

  const save = () => {
    if (!dob) return;
    fetch(`${API}/user/birthdate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id: userId, dob, birth_city: city }),
    }).then(() => { setSaved(true); onSaved?.(); });
  };

  if (saved) return null;

  return (
    <div style={{ marginBottom: "16px", borderRadius: "12px", overflow: "hidden",
      border: "1px solid var(--border)", background: "var(--bg2)" }}>
      <div onClick={() => setOpen(o => !o)} style={{
        padding: "12px 16px", cursor: "pointer",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <div style={{ fontSize: "1.0rem", color: "var(--saffron)", fontWeight: 600 }}>
          🪐 Add your birth details for personalised panchang
        </div>
        <span style={{ color: "var(--text-dim)", fontSize: "1.0rem" }}>{open ? "▲" : "▼"}</span>
      </div>
      {open && (
        <div style={{ padding: "0 16px 14px", display: "flex", flexDirection: "column", gap: "10px" }}>
          <input type="date" value={dob} onChange={e => setDob(e.target.value)}
            style={{ background: "var(--bg3)", border: "1px solid var(--border)", borderRadius: "8px",
              padding: "8px 12px", color: "var(--text)", fontSize: "1.0rem", width: "100%", boxSizing: "border-box" }} />
          <input type="text" placeholder="Birth city (optional)" value={city} onChange={e => setCity(e.target.value)}
            style={{ background: "var(--bg3)", border: "1px solid var(--border)", borderRadius: "8px",
              padding: "8px 12px", color: "var(--text)", fontSize: "1.0rem", width: "100%", boxSizing: "border-box" }} />
          <button onClick={save} style={{ background: "var(--saffron)", border: "none", borderRadius: "8px",
            padding: "9px", color: "#FFFFFF", fontWeight: 700, cursor: "pointer", fontSize: "1.0rem" }}>
            Save
          </button>
        </div>
      )}
    </div>
  );
}

// ── Hora (Planetary Hour) tracker ────────────────────────────────────────────
// `color`/`bg`/`border` stay for the small "current hora" highlight (an active
// state, per design rules) — anywhere the quality is shown as ordinary row
// text it must use the darker, legible `text` shade instead.
const HORA_Q_PANCHANG = {
  excellent: { label:"Excellent", color:"#fbbf24", bg:"rgba(251,191,36,0.12)", border:"rgba(251,191,36,0.35)", text:TXT.amber },
  good:      { label:"Good",      color:"#22c55e", bg:"rgba(34,197,94,0.10)",  border:"rgba(34,197,94,0.3)",  text:TXT.green },
  neutral:   { label:"Neutral",   color:"#94a3b8", bg:"rgba(148,163,184,0.08)",border:"rgba(148,163,184,0.25)", text:"#475569" },
  avoid:     { label:"Avoid",     color:"#f87171", bg:"rgba(248,113,113,0.10)",border:"rgba(248,113,113,0.3)", text:TXT.red },
};

function HoraSection() {
  const [data, setData] = useState(null);
  const [now, setNow]   = useState(new Date());

  useEffect(() => {
    fetch(`${API}/panchang/hora`)
      .then(r => r.json()).then(setData).catch(() => {});
  }, []);

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(id);
  }, []);

  if (!data) return (
    <div style={{ height:200, borderRadius:"18px",
      background:"linear-gradient(90deg,var(--bg2) 25%,var(--bg3) 50%,var(--bg2) 75%)",
      backgroundSize:"200% 100%", animation:"shimmer 1.4s infinite" }} />
  );

  const curMin = now.getHours() * 60 + now.getMinutes();
  let currentIdx = data.current_hora_index;
  for (const h of data.horas) {
    const { start_min: s, end_min: e } = h;
    if (e < s) { if (curMin >= s || curMin < e) { currentIdx = h.index; break; } }
    else        { if (s <= curMin && curMin < e) { currentIdx = h.index; break; } }
  }
  const current = data.horas[currentIdx] || data.horas[0];
  const qs = HORA_Q_PANCHANG[current?.quality] || HORA_Q_PANCHANG.neutral;

  return (
    <div>
      <div style={{
        background: qs.bg,
        border:`2px solid ${qs.border}`, borderRadius:"18px", padding:"20px",
        marginBottom:"20px", boxShadow:"var(--card-shadow)",
      }}>
        <div style={{ fontSize:"1.0rem", color:"var(--text-dim)", fontWeight:700,
          fontFamily:font.title, marginBottom:"6px" }}>Current Hora</div>
        <div style={{ display:"flex", alignItems:"center", gap:"14px" }}>
          <span style={{ fontSize:"2.8rem" }}>{current?.icon}</span>
          <div>
            <div style={{ fontSize:"1.5rem", color:qs.text, fontWeight:700,
              fontFamily:font.title }}>{current?.ruler}</div>
            <div style={{ fontSize:"1rem", color:"var(--text)", marginTop:"2px" }}>
              {current?.start} – {current?.end} IST</div>
          </div>
          <div style={{ marginLeft:"auto" }}>
            <div style={{ fontSize:"1.0rem", fontWeight:700, color:qs.text,
              background:"var(--bg2)", border:`1px solid ${qs.border}`,
              borderRadius:"8px", padding:"4px 10px" }}>{qs.label}</div>
          </div>
        </div>
        <div style={{ marginTop:"10px", fontSize:"1.0rem", color:"var(--text)",
          fontFamily:font.body }}>{current?.ideal_en}</div>
        <div style={{ marginTop:"8px", display:"flex", gap:"16px", fontSize:"1.0rem", color:"var(--text-dim)" }}>
          <span>🌅 Sunrise {data.sunrise}</span><span>🌇 Sunset {data.sunset}</span>
        </div>
      </div>

      <div style={{ fontFamily:font.title, fontSize:"1.0rem", fontWeight:700,
        color:"var(--saffron)", marginBottom:"12px" }}>All 24 Horas</div>

      <div style={{ fontSize:"1.0rem", color:"var(--text-dim)",
        marginBottom:"8px", fontWeight:600 }}>☀️ Daytime · {data.sunrise} – {data.sunset}</div>
      <div style={{ display:"flex", flexDirection:"column", gap:"6px", marginBottom:"14px" }}>
        {data.horas.filter(h => h.type === "day").map(h => {
          const q = HORA_Q_PANCHANG[h.quality] || HORA_Q_PANCHANG.neutral;
          const isCur = h.index === currentIdx;
          return (
            <div key={h.index} style={{
              display:"flex", alignItems:"center", gap:"12px",
              background: isCur ? q.bg : "var(--bg2)",
              border:`1px solid ${isCur ? q.border : "var(--border)"}`,
              borderRadius:"10px", padding:"10px 14px",
            }}>
              <span style={{ fontSize:"1.4rem", minWidth:"28px" }}>{h.icon}</span>
              <div style={{ flex:1 }}>
                <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
                  <span style={{ fontSize:"1.0rem", fontWeight:700,
                    color: isCur ? q.text : "var(--text)" }}>{h.ruler}</span>
                  {isCur && <span style={{ fontSize:"0.95rem", color:q.text, fontWeight:700,
                    background:"var(--bg2)", border:`1px solid ${q.border}`,
                    borderRadius:"6px", padding:"1px 6px" }}>NOW</span>}
                </div>
                <div style={{ fontSize:"1.0rem", color:"var(--text-dim)", marginTop:"1px" }}>
                  {h.start} – {h.end}</div>
              </div>
              <div style={{ fontSize:"1.0rem", color:q.text, fontWeight:600,
                textAlign:"right", minWidth:"60px" }}>{q.label}</div>
            </div>
          );
        })}
      </div>

      <div style={{ fontSize:"1.0rem", color:"var(--text-dim)",
        marginBottom:"8px", fontWeight:600 }}>🌙 Nighttime · {data.sunset} onwards</div>
      <div style={{ display:"flex", flexDirection:"column", gap:"6px" }}>
        {data.horas.filter(h => h.type === "night").map(h => {
          const q = HORA_Q_PANCHANG[h.quality] || HORA_Q_PANCHANG.neutral;
          const isCur = h.index === currentIdx;
          return (
            <div key={h.index} style={{
              display:"flex", alignItems:"center", gap:"12px",
              background: isCur ? q.bg : "var(--bg2)",
              border:`1px solid ${isCur ? q.border : "var(--border)"}`,
              borderRadius:"10px", padding:"10px 14px",
              opacity:0.92,
            }}>
              <span style={{ fontSize:"1.4rem", minWidth:"28px" }}>{h.icon}</span>
              <div style={{ flex:1 }}>
                <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
                  <span style={{ fontSize:"1.0rem", fontWeight:700,
                    color: isCur ? q.text : "var(--text)" }}>{h.ruler}</span>
                  {isCur && <span style={{ fontSize:"0.95rem", color:q.text, fontWeight:700,
                    background:"var(--bg2)", border:`1px solid ${q.border}`,
                    borderRadius:"6px", padding:"1px 6px" }}>NOW</span>}
                </div>
                <div style={{ fontSize:"1.0rem", color:"var(--text-dim)", marginTop:"1px" }}>
                  {h.start} – {h.end}</div>
              </div>
              <div style={{ fontSize:"1.0rem", color:q.text, fontWeight:600,
                textAlign:"right", minWidth:"60px" }}>{q.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}


export default function PanchangPage({ onBack, user }) {
  const today = new Date();
  const [lang,        setLang]        = useState(() => localStorage.getItem("panchang_lang") || "te");
  const [tab,         setTab]         = useState("panchang"); // "panchang" | "muhurta" | "hora"
  const [hasBirthDate, setHasBirthDate] = useState(true); // assume true; API call below
  const [year,        setYear]        = useState(today.getFullYear());
  const [month,       setMonth]       = useState(today.getMonth()); // 0-indexed
  const [todayData,   setTodayData]   = useState(null);
  const [monthData,   setMonthData]   = useState([]);
  const [selectedDay, setSelectedDay] = useState(null);
  const [loadingToday,  setLoadingToday]  = useState(true);
  const [loadingMonth,  setLoadingMonth]  = useState(true);

  useEffect(() => {
    if (user?.id) {
      fetch(`${API}/user/birthdate/${user.id}`)
        .then(r => r.ok ? r.json() : null)
        .then(d => setHasBirthDate(!!(d && d.dob)))
        .catch(() => {});
    }
  }, [user?.id]);

  useEffect(() => {
    fetch(`${API}/panchang/today`)
      .then(r => r.json())
      .then(d => { setTodayData(d); setLoadingToday(false); })
      .catch(() => setLoadingToday(false));
  }, []);

  useEffect(() => {
    setLoadingMonth(true);
    setSelectedDay(null);
    fetch(`${API}/panchang/month/${year}/${month + 1}?lang=${lang}`)
      .then(r => r.json())
      .then(d => { setMonthData(d.days || []); setLoadingMonth(false); })
      .catch(() => setLoadingMonth(false));
  }, [year, month, lang]);

  const changeLang = (l) => { setLang(l); localStorage.setItem("panchang_lang", l); };

  const prevMonth = () => { if (month === 0) { setYear(y => y-1); setMonth(11); } else setMonth(m => m-1); };
  const nextMonth = () => { if (month === 11) { setYear(y => y+1); setMonth(0); } else setMonth(m => m+1); };

  const L = LANG[lang];

  return (
    <div className="page">
      {/* Back */}
      <button onClick={onBack} style={{ background:"none", border:"none", cursor:"pointer",
        color:"var(--text-dim)", fontFamily:regionalFont(lang), fontSize:"1rem",
        padding:"0", marginBottom:"20px", display:"flex", alignItems:"center", gap:"6px" }}>
        {L.back}
      </button>

      {/* Birth date prompt for existing users */}
      {user?.id && !hasBirthDate && (
        <BirthDatePrompt userId={user.id} onSaved={() => setHasBirthDate(true)} />
      )}

      {/* Title + language selector */}
      <div style={{ marginBottom:"16px" }}>
        <div style={{ marginBottom:"8px" }}>
          <div style={{ fontFamily:regionalFont(lang), fontSize:"1.5rem", fontWeight:700, color:"var(--text)" }}>
            {L.title}
          </div>
          <div style={{ fontSize:"1.0rem", color:"var(--text-dim)", fontFamily:regionalFont(lang) }}>
            {L.subtitle}
          </div>
        </div>
        <LangSelector lang={lang} onChange={changeLang} />
      </div>

      {/* Tab bar */}
      <div style={{ display:"flex", gap:"8px", marginBottom:"20px" }}>
        {[
          { id:"panchang", label:`📅 ${L.title}` },
          { id:"muhurta",  label:`⏰ ${(MUHURTA_LANG[lang] || MUHURTA_LANG.en).heading}` },
          { id:"hora",     label:`🕐 Hora` },
        ].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            flex:1, padding:"12px 8px", minHeight:"46px",
            background: tab === t.id ? "rgba(232,131,42,0.10)" : "var(--bg2)",
            border:`1px solid ${tab === t.id ? "var(--saffron)" : "var(--border)"}`,
            borderRadius:"12px", cursor:"pointer",
            color: tab === t.id ? "var(--saffron)" : "var(--text-dim)",
            fontFamily:regionalFont(lang), fontWeight:700, fontSize:"1.0rem",
            transition:"all 0.2s",
          }}>{t.label}</button>
        ))}
      </div>

      {/* Muhurta tab */}
      {tab === "muhurta" && <MuhurtaSection lang={lang} />}

      {/* Hora tab */}
      {tab === "hora" && <HoraSection />}

      {/* Panchang tab */}
      {tab === "panchang" && (<>

      {loadingToday ? (
        <div style={{ height:200, borderRadius:"18px", marginBottom:"20px",
          background:"linear-gradient(90deg,var(--bg2) 25%,var(--bg3) 50%,var(--bg2) 75%)",
          backgroundSize:"200% 100%", animation:"shimmer 1.4s infinite" }} />
      ) : (
        <TodayBanner data={todayData} lang={lang} />
      )}

      {/* Month navigation */}
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"14px" }}>
        <button onClick={prevMonth} style={{ background:"var(--bg2)", border:"1px solid var(--border)",
          borderRadius:"8px", padding:"8px 18px", color:"var(--text-dim)", cursor:"pointer", fontSize:"1.1rem" }}>‹</button>

        <div style={{ textAlign:"center" }}>
          <div style={{ fontFamily:regionalFont(lang), fontSize:"1.1rem", fontWeight:700, color:"var(--text)" }}>
            {L.months[month]} {year}
          </div>
        </div>

        <button onClick={nextMonth} style={{ background:"var(--bg2)", border:"1px solid var(--border)",
          borderRadius:"8px", padding:"8px 18px", color:"var(--text-dim)", cursor:"pointer", fontSize:"1.1rem" }}>›</button>
      </div>

      {/* Legend */}
      <div style={{ display:"flex", gap:"12px", flexWrap:"wrap", marginBottom:"14px" }}>
        {[
          { color:"#e8832a", label:L.festivalLbl },
          { color:"#c9953a", label:L.purnimaLbl },
          { color:"#818cf8", label:L.amaavasyaLbl },
          { color:"#34d399", label:L.ekadashiLbl },
        ].map(item => (
          <div key={item.label} style={{ display:"flex", alignItems:"center", gap:"5px" }}>
            <div style={{ width:10, height:10, borderRadius:"50%", background:item.color }} />
            <span style={{ fontSize:"1.0rem", color:"var(--text-dim)", fontFamily:regionalFont(lang) }}>{item.label}</span>
          </div>
        ))}
      </div>

      {/* Calendar */}
      {loadingMonth ? (
        <div style={{ height:320, borderRadius:"12px",
          background:"linear-gradient(90deg,var(--bg2) 25%,var(--bg3) 50%,var(--bg2) 75%)",
          backgroundSize:"200% 100%", animation:"shimmer 1.4s infinite" }} />
      ) : (
        <MonthCalendar
          monthData={monthData}
          selectedDay={selectedDay}
          onSelectDay={d => setSelectedDay(prev => prev?.date === d.date ? null : d)}
          lang={lang}
        />
      )}

      {/* Day detail */}
      {selectedDay && (
        <DayDetail day={selectedDay} lang={lang} onClose={() => setSelectedDay(null)} />
      )}

      {/* Key days this month */}
      {!loadingMonth && monthData.length > 0 && (
        <div style={{ marginTop:"20px", padding:"18px 20px", background:"var(--bg2)",
          border:"1px solid var(--border)", borderRadius:"14px", boxShadow:"var(--card-shadow)" }}>
          <div style={sectionTitleStyle(lang)}>
            {L.keyDays}
          </div>
          <div style={{ display:"flex", flexWrap:"wrap", gap:"10px" }}>
            {monthData.filter(d => d.is_ekadashi || d.is_purnima || d.is_amavasya || d.festival).map(d => {
              const sty = dayStyle(d);
              return (
                <div key={d.day} onClick={() => setSelectedDay(d)} style={{
                  background:sty.bg, border:`1px solid ${sty.border}`,
                  borderRadius:"10px", padding:"9px 16px", cursor:"pointer",
                  transition:"all 0.15s",
                }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = "var(--saffron)"; e.currentTarget.style.boxShadow = "var(--card-shadow-hover)"; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = sty.border; e.currentTarget.style.boxShadow = "none"; }}
                >
                  <div style={{ fontSize:"1.08rem", color:sty.badge, fontWeight:800, fontFamily:regionalFont(lang) }}>
                    {d.day} {L.months[month].slice(0,3)}
                  </div>
                  <div style={{ fontSize:"1.05rem", color:"var(--text)", fontWeight:500, fontFamily:regionalFont(lang) }}>
                    {d.festival || tTithi(d.tithi_en, d.tithi_te, lang)}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      </>)}
    </div>
  );
}
